<main id="main" class="main">
  <section class="section dashboard">
    <div class="row">
      <div class="col-sm-10">
        <!-- Main Corporate Details Form -->
        <div class="row">
          <div class="col-sm-12">
            <form class="onbordingform linescrollbar form-container" [formGroup]="brokerregform">
              <!-- <fieldset disabled="disabled" id="fieldsetattr"> -->
              <div class="row">
                <div class="form-group col-12">
                  <h6 class="admintitle">
                    <span class="bartitlelabel">{{lang.Advisor_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i></span>
                  </h6>
                </div>
              </div>
              <div class="input-wrapper row" *ngIf="allBrokers && allBrokers.length > 0">
                <div class="form-group col-6">
                  <label for="Corporation" class="Corporation">{{lang.Brokerage_Parent_Advisor}}</label>

                  <select class="form-control select2" id="parentidrole" placeholder="Select" disabled
                    formControlName="ParentbrokerName" data-live-search="true" [ngModel]="parentBrokerName">
                    <option [value]="parentBrokerName">{{parentBrokerName}}</option>

                  </select>

                  <!-- <div *ngIf="client['corporationName'].touched && client['corporationName'].invalid" class="help-block text-danger">
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please enter corporation name</div>
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">Corporation name should be 3 character</div>
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">Corporation name must not exceed 30 characters</div>
                </div> -->
                </div>
                <div class="form-group col-6">
                  <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>

                  <select class="form-control" id="brokerType" [ngModel]="brokerinfobrokerType" placeholder="Select"
                    (change)="brokertype(brokername.value)" #brokername formControlName="brokerType" (change)="checkRole($event)">
                    <option value="" disbaled>{{lang.Select}}</option>

                    <option *ngFor="let name of brokerType" [value]="name.label">
                      {{ name.display }}
                    </option>
                  </select>
                  <div *ngIf="
                      broker['brokerType'].touched &&
                      broker['brokerType'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['brokerType'].errors &&
                        broker['brokerType'].errors['required']
                      ">
                      {{lang.Please_select_broker_status}}
                    </div>
                    <!-- <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['minlength']">Broker name should be 3 character</div>
                  <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['maxlength']">Broker name must not exceed 30 characters</div> -->
                  </div>
                </div>
              </div>
              <div class="input-wrapper row">
                <div class="form-group col-6">
                  <label for="Corporation" class="Corporation">{{lang.Name_of_Broker}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="nameofcorporation"
                    [(ngModel)]="brokerinfoName" placeholder={{lang.Name_of_Broker}} style="text-transform: capitalize"
                    disabled formControlName="brokersName" />
                  <div *ngIf="
                      broker['brokersName'].touched &&
                      broker['brokersName'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['brokersName'].errors &&
                        broker['brokersName'].errors['required']
                      ">
                      {{lang.Please_enter_broker_name}}
                    </div>
                    <div *ngIf="
                        broker['brokersName'].errors &&
                        broker['brokersName'].errors['minlength']
                      ">
                      {{lang.Broker_name_must_be_atleast_3_characters}}
                    </div>
                    <div *ngIf="
                        broker['brokersName'].errors &&
                        broker['brokersName'].errors['maxlength']
                      ">
                      {{lang.Broker_name_must_not_exceed_255_characters}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-6" *ngIf="showBusinessnumber">
                  <label for="Corporation" class="Corporation">{{lang.Business_Number}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="businessnumber"
                    placeholder={{lang.Business_Number}} formControlName="businessnumber" />
                  <div *ngIf="
                      broker['businessnumber'].touched &&
                      broker['businessnumber'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['businessnumber'].errors &&
                        broker['businessnumber'].errors['required']
                      ">
                      {{lang.Please_enter_business_number}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-3">
                  <label for="Corporation" class="Corporation">{{lang.Phone}}<span style="color: red">*</span>
                  </label>

                  <input type="text" class="form-control checking-field" id="primaryPhone" placeholder={{lang.Phone}}
                    [(ngModel)]="primaryPhone" formControlName="primaryPhone" (change)="
                      phoneFormatForGroupCont(brokerregform, 'primaryPhone')
                    " />
                  <div *ngIf="
                      broker['primaryPhone'].touched &&
                      broker['primaryPhone'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['primaryPhone'].errors &&
                        broker['primaryPhone'].errors['required']
                      ">
                      {{lang.Please_enter_phone_number}}
                    </div>
                    <div *ngIf="
                        broker['primaryPhone'].errors &&
                        broker['primaryPhone'].errors['minlength']
                      ">
                      {{lang.Phone_number_minimum_of_10_digits}}
                    </div>
                    <div *ngIf="
                        broker['primaryPhone'].errors &&
                        broker['primaryPhone'].errors['maxlength']
                      ">
                      {{lang.Phone_number_maximum_of_10_digits}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="Corporation" class="Corporation">{{lang.Secondary_Phone}}
                  </label>

                  <input type="text" class="form-control checking-field" id="secondaryPhone"
                    placeholder={{lang.Secondary_Phone}} [(ngModel)]="secondaryPhone" formControlName="secondaryPhone"
                    (change)="
                      phoneFormatForGroupCont(brokerregform, 'secondaryPhone')
                    " />

                  <div *ngIf="
                      broker['secondaryPhone'].touched &&
                      broker['secondaryPhone'].invalid
                    " class="help-block text-danger">
                    <!-- <div *ngIf="broker['primaryPhone'].errors && broker['primaryPhone'].errors['required']">{{lang.Please_enter_phone_number}}</div> -->
                    <div *ngIf="
                        broker['secondaryPhone'].errors &&
                        broker['secondaryPhone'].errors['minlength']
                      ">
                      {{lang.Phone_number_minimum_of_10_digits}}
                    </div>
                    <div *ngIf="
                        broker['secondaryPhone'].errors &&
                        broker['secondaryPhone'].errors['maxlength']
                      ">
                      {{lang.Phone_number_maximum_of_10_digits}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-3">
                  <!-- <i class="fa fa-eye" aria-hidden="true"></i> -->
                  <label for="Corporation" class="Corporation">{{lang.Email}}&nbsp;<span style="color: red">*</span></label>
                  <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                    [(ngModel)]="primaryEmail" formControlName="primaryEmail" />
                  <div *ngIf="
                      broker['primaryEmail'].touched &&
                      broker['primaryEmail'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['primaryEmail'].errors &&
                        broker['primaryEmail'].errors['required']
                      ">
                     {{lang.Please_enter_email}}
                    </div>
                    <div *ngIf="
                        broker['primaryEmail'].errors &&
                        broker['primaryEmail'].errors['pattern']
                      ">
                      {{lang.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-3">
                  <!-- <i class="fa fa-plus" data-bs-toggle="modal" data-bs-target="#addExtraEmail" aria-hidden="true"></i> -->
                  <label for="Corporation" class="Corporation">{{lang.Secondary_Email}} &nbsp;</label>

                  <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Secondary_Email}}
                    [(ngModel)]="secondaryEmail" formControlName="secondaryEmail" />

                  <div *ngIf="
                      broker['secondaryEmail'].touched &&
                      broker['secondaryEmail'].invalid
                    " class="help-block text-danger">
                    <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                    <div *ngIf="
                        broker['secondaryEmail'].errors &&
                        broker['secondaryEmail'].errors['pattern']
                      ">
                      {{lang.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-4">
                  <!-- <i class="fa fa-plus" data-bs-toggle="modal" data-bs-target="#addExtraEmail" aria-hidden="true"></i> -->
                  <label for="Corporation" class="Corporation">{{lang.Third_Email}} &nbsp;</label>

                  <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Third_Email}}
                    formControlName="thirdEmail" [(ngModel)]="thirdEmail" />

                  <div *ngIf="
                      broker['thirdEmail'].touched &&
                      broker['thirdEmail'].invalid
                    " class="help-block text-danger">
                    <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                    <div *ngIf="
                        broker['thirdEmail'].errors &&
                        broker['thirdEmail'].errors['pattern']
                      ">
                      {{lang.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-4">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="Street_Address"
                    placeholder={{lang.Street_Address}} [(ngModel)]="streetAddressline1" formControlName="streetAddress" />
                  <div *ngIf="
                      broker['streetAddress'].touched &&
                      broker['streetAddress'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['streetAddress'].errors &&
                        broker['streetAddress'].errors['required']
                      ">
                      {{lang.Please_enter_street_address_name}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-4">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address_Line_2}}</label>

                  <input type="text" class="form-control checking-field" id="StreetAddreess2"
                    [(ngModel)]="streetAddressline2" placeholder={{lang.Street_Address_Line_2}}
                    formControlName="streetAddress2" />
                </div>
              </div>

              <div class="row" style="margin-top: 5px">
                <div class="form-group col-3">
                  <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                  <select class="form-control" id="country" placeholder="Country" formControlName="country"
                    [ngModel]="country">
                    <option value="" disabled>{{lang.Select}}</option>
                    <option value="Canada" selected>Canada</option>
                    <!-- <option value="usa">USA</option> -->

                    <!-- <option
                    *ngFor="let name of configprovinceres"
                    [value]="name.shortName"
                  >
                    {{ name.shortName }}
                  </option> -->
                  </select>
                  <div *ngIf="
                      broker['country'].touched && broker['country'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['country'].errors &&
                        broker['country'].errors['required']
                      ">
                      {{lang.Please_select_country}}
                    </div>
                    <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
                    <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="city" [(ngModel)]="city" placeholder={{lang.City}}
                    style="text-transform: capitalize" formControlName="city" />
                  <div *ngIf="broker['city'].touched && broker['city'].invalid" class="help-block text-danger">
                    <div *ngIf="
                        broker['city'].errors &&
                        broker['city'].errors['required']
                      ">
                      {{lang.Please_enter_city_name}}
                    </div>
                    <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
                  <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

                  <select class="form-control" id="Province" placeholder="Province" [(ngModel)]="state"
                    formControlName="Province" (change)="provincelist($event)">
                    <option value="">{{lang.Select}}</option>

                    <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                      {{ name.shortName }}
                    </option>
                  </select>

                  <div *ngIf="
                      broker['Province'].touched && broker['Province'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['Province'].errors &&
                        broker['Province'].errors['required']
                      ">
                      {{lang.Please_select_province}}
                    </div>
                    <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
                <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="Corporation" class="Corporation">{{lang.Postal_Code}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" [(ngModel)]="postalCode" id="postalcode"
                    placeholder={{lang.Postal_Code}} onkeyup="this.value = this.value.toUpperCase();"
                    formControlName="postalCode" (input)="changeTextToUppercase('postalcode', $event)" />
                  <div *ngIf="broker['postalCode'].touched" class="help-block text-danger">
                    <div *ngIf="
                        broker['postalCode'].errors &&
                        broker['postalCode'].errors['required']
                      ">
                      {{lang.Please_enter_postal_code}}
                    </div>
                    <div *ngIf="
                        invalidpostalcodeprivince ||
                        (broker['postalCode'].touched &&
                          broker['postalCode'].hasError('invalidPostalCode'))
                      ">
                      {{lang.Please_enter_valid_postal_code}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="form-group col-12">
                  <h6 class="admintitle">
                    {{lang.Group_Contacts}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div>
              </div>

              <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()" *ngIf="addadminform">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.First_Name}}<span  style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                        formControlName="firstName" style="text-transform: capitalize" />

                      <div *ngIf="
                          grpcontact['firstName'].touched &&
                          grpcontact['firstName'].invalid
                        " class="help-block text-danger">
                        <div *ngIf="
                            grpcontact['firstName'].errors &&
                            grpcontact['firstName'].errors['required']
                          ">
                          {{lang.Please_enter_first_Name}}
                        </div>
                        <div *ngIf="
                            grpcontact['firstName'].errors &&
                            grpcontact['firstName'].errors['minlength']
                          ">
                          {{lang.First_Name_should_be_3_characters}}
                        </div>
                        <div *ngIf="
                            grpcontact['firstName'].errors &&
                            grpcontact['firstName'].errors['maxlength']
                          ">
                          {{lang.First_name_must_not_exceed_20_characters}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span  style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                        style="text-transform: capitalize" formControlName="lastName" />

                      <div *ngIf="
                          grpcontact['lastName'].touched &&
                          grpcontact['lastName'].invalid
                        " class="help-block text-danger">
                        <div *ngIf="
                            grpcontact['lastName'].errors &&
                            grpcontact['lastName'].errors['required']
                          ">
                          {{lang.Please_enter_Last_Name}}
                        </div>
                        <div *ngIf="
                            grpcontact['lastName'].errors &&
                            grpcontact['lastName'].errors['minlength']
                          ">
                          {{lang.Last_Name_should_be_3_characters}}
                        </div>
                        <div *ngIf="
                            grpcontact['lastName'].errors &&
                            grpcontact['lastName'].errors['maxlength']
                          ">
                          {{lang.Last_Name_must_not_exceed_20_characters}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span  style="color: red">*</span></label>

                      <input type="tel" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}} (change)="
                          phoneFormatForGroupCont(adminform, 'phoneNum')
                        " formControlName="phoneNum" />

                      <div *ngIf="
                          grpcontact['phoneNum'].touched &&
                          grpcontact['phoneNum'].invalid
                        " class="help-block text-danger">
                        <div *ngIf="
                            grpcontact['phoneNum'].errors &&
                            grpcontact['phoneNum'].errors['required']
                          ">
                          {{lang.Please_enter_phone_number}}
                        </div>
                        <div *ngIf="
                            grpcontact['phoneNum'].errors &&
                            grpcontact['phoneNum'].errors['minlength']
                          ">
                          {{lang.Phone_number_minimum_of_10_digits}}
                        </div>
                        <div *ngIf="
                            grpcontact['phoneNum'].errors &&
                            grpcontact['phoneNum'].errors['maxlength']
                          ">
                          {{lang.Phone_number_maximum_of_10_digits}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                        formControlName="email" />
                      <div *ngIf="
                          grpcontact['email'].touched &&
                          grpcontact['email'].invalid
                        " class="help-block text-danger">
                        <div *ngIf="
                            grpcontact['email'].errors &&
                            grpcontact['email'].errors['required']
                          ">
                         {{lang.Please_enter_email}}
                        </div>
                        <div *ngIf="
                            grpcontact['email'].errors &&
                            grpcontact['email'].errors['pattern']
                          ">
                          {{lang.Please_enter_valid_email}}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>

                      <select (change)="groupContactChange($event)" class="form-control" id="adminrole"
                        formControlName="role" placeholder="Role">
                        <option value="" disabled>{{lang.Select}}</option>
                        <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                          {{ name.display }}
                        </option>
                      </select>

                      <div *ngIf="
                          grpcontact['role'].touched &&
                          grpcontact['role'].invalid
                        " class="help-block text-danger">
                        <div *ngIf="
                            grpcontact['role'].errors &&
                            grpcontact['role'].errors['required']
                          ">
                          {{lang.Please_select_role}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4" *ngIf="ShowOthers">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Others}}<span  style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="roleName" placeholder="Others"
                        formControlName="roleName" />
                      <div *ngIf="
                          grpcontact['roleName'].touched &&
                          grpcontact['roleName'].invalid
                        " class="help-block text-danger">
                        <div *ngIf="
                            grpcontact['roleName'].errors &&
                            grpcontact['roleName'].errors['required']
                          ">
                          {{lang.please_enter_role}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 pt-2">
                    <button [hidden]="adminform.invalid" type="submit" class="btn btn-primary">
                      {{lang.Save}}
                    </button>
                  </div>
                </div>
              </form>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <div class="form-group">
                    <div style="overflow: auto; direction: ltr; width: 100%">
                      <table align="left" *ngIf="showaddadmin">
                        <tr>
                          <th>{{lang.First_Name}}</th>
                         <th>{{lang.Last_Name}}</th>
                          <th>{{lang.Phone_Number}}</th>
                          <th>{{lang.Email}}</th>
                          <th>{{lang.Role}}</th>
                          <th></th>
                        </tr>
                        <tbody>
                          <tr *ngFor="let admin of adminData; let i = index" [ngClass]="{
                              orange: i % 2 == 0,
                              white: i % 2 != 0
                            }">
                            <td>{{ admin.firstName }}</td>
                            <td>{{ admin.lastName }}</td>
                            <td>{{ admin.phoneNum }}</td>
                            <td>{{ admin.email }}</td>
                            <td>
                              <span *ngIf="admin.role == 'ADVISOR_EXECUTIVE'">{{lang.Executive}}</span>
                              <span *ngIf="admin.role == 'ADVISOR_ADMINISTRATOR'">{{lang.Administrator}}</span>
                              <span *ngIf="admin.role == 'ADVISOR_CONTACT'">{{lang.Support}}</span>
                              <span *ngIf="admin.role == 'ADVISOR_OTHERS'">{{admin.roleName}}</span>
                            </td>

                            <!-- <td *ngFor="let item of advisorGroupContact">
                            <span *ngIf="admin.role=='item.key'">{{item.display}}</span>

                          </td> -->

                            <td style="text-align: right; display: flex">
                              <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaleditgroupcontact"(click)="editadmin(admin,i)">Edit</button>&nbsp;
                          <button class="brokertablestatus" style="color:red" (click)="deleteadmin(admin,i)">Delete</button> -->
                              <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                data-bs-target="#basicModaleditgroupcontact" (click)="editadmin(admin, i)">
                                <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                class="btn btn-default deleteicon" (click)="deleteadmin(admin, i)">
                                <i class="bi bi-trash-fill"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <button *ngIf="showaddadmin" class="btn btn-primary addgroupadmininfo" type="button"
                    data-bs-toggle="modal" data-bs-target="#basicModaladdgrpcontact" (click)="hidegrpadmindetails()">
                    {{lang.Add_More}}
                  </button>
                </div>
              </div>

              <!-- LinceInformation -->

              <div class="row">
                <div class="form-group col-12 mb-2">
                  <h6 class="admintitle">
                    {{lang.License_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div>
              </div>

              <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()" *ngIf="showlicenseForm">
                <div class="input-wrapper row">
                  <div class="form-group col-4 mb-2">
                    <label for="Corporation" class="Corporation">{{lang.License}} #<span  style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="licenseNumber"
                      placeholder={{lang.License}} formControlName="licenseNumber" style="text-transform: capitalize" />

                    <div *ngIf="
                        f['licenseNumber'].touched && f['licenseNumber'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          f['licenseNumber'].errors &&
                          f['licenseNumber'].errors['required']
                        ">
                        {{lang.Please_enter_license_number}}
                      </div>
                      <div *ngIf="
                          f['licenseNumber'].errors &&
                          f['licenseNumber'].errors['minlength']
                        ">
                        {{lang.License_number_must_be_atleast_3_characters}}
                      </div>
                      <div *ngIf="
                          f['licenseNumber'].errors &&
                          f['licenseNumber'].errors['maxlength']
                        ">
                        {{lang.License_number_must_not_exceed_100_characters}}s
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

                    <select class="form-control" formControlName="licenseCoverage">
                      <option value="" disabled>{{lang.Select}}</option>
                      <option *ngFor="let name of licenseCoverage" [value]="name.label">
                        {{ name.display }}
                      </option>
                    </select>

                    <div *ngIf="
                        f['licenseCoverage'].touched &&
                        f['licenseCoverage'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          f['licenseCoverage'].errors &&
                          f['licenseCoverage'].errors['required']
                        ">
                        {{lang.Please_select_license_coverage}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

                    <select class="form-control" id="state" placeholder="state" formControlName="state"
                      (change)="insuranceprovincelist($event)">
                      <option value="" disabled>{{lang.Select}}</option>

                      <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                        {{ name.shortName }}
                      </option>
                    </select>

                    <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                      <div *ngIf="
                          f['state'].errors && f['state'].errors['required']
                        ">
                        {{lang.Please_select_province}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>

                    <input type="text" placeholder="MM-DD-YYYY" class="form-control" [min]="minDate"
                      formControlName="expiryDate" (keypress)="dateExpression($event)" bsDatepicker
                      [minDate]="todayDate" [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
                      (onShown)="disableScrolling()" (onHidden)="enableScrolling()" />
                    <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                      <div *ngIf="
                          f['expiryDate'].errors &&
                          f['expiryDate'].errors['required']
                        ">
                        {{lang.Please_select_expiry_date}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
                    <input type="text" class="form-control checking-field" id="remainder_days" value="30"
                      placeholder={{lang.Reminder_Days}} (keypress)="numberOnly($event)" formControlName="remainder_days"
                      style="text-transform: capitalize" />

                    <div *ngIf="
                        f['remainder_days'].touched &&
                        f['remainder_days'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          f['remainder_days'].errors &&
                          f['remainder_days'].errors['required']
                        ">
                        {{lang.Please_enter_reminder_email_days}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-4">
                    <button type="submit" [hidden]="licenseform.invalid" class="btn btn-primary">
                      {{lang.Save}}
                    </button>
                  </div>
                </div>
              </form>
              <!-- lincenseInfo Table -->
              <div class="row" *ngIf="!showlicenseForm">
                <div class="form-group col-12 mb-2">
                  <div style="direction: ltr; width: 100%">
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <table align="left">
                          <tr>
                            <th>{{lang.License}} #</th>
                            <th>{{lang.Coverage}} </th>
                            <th>{{lang.Province}} </th>
                            <th>{{lang.Expiry_Date}} </th>
                            <th>{{lang.Reminder_Days}} </th>
                            <th></th>
                          </tr>
                          <tbody>
                            <tr *ngFor="
                                let broker of brokerLicensedStatesAndProvinces;
                                let i = index
                              " [ngClass]="{
                                orange: i % 2 == 0,
                                white: i % 2 != 0
                              }">
                              <td>
                                <input type="text" class="form-control checking-field" id="licenseNumber"
                                  [(ngModel)]="broker.licenseNumber" [ngModelOptions]="{ standalone: true }" [disabled]="
                                    isEditable || enableEditIndex != i
                                  " />
                              </td>
                              <td>
                                <select class="form-control" id="licenseCoverage" placeholder="Select"
                                  [(ngModel)]="broker.licenseCoverage" [ngModelOptions]="{ standalone: true }"
                                  [disabled]="
                                    isEditable || enableEditIndex != i
                                  ">
                                  <option value="">{{lang.Select}}</option>

                                  <option *ngFor="let name of licenseCoverage" [value]="name.label">
                                    {{ name.display }}
                                  </option>
                                </select>
                              </td>
                              <td>
                                <select class="form-control" id="province" placeholder="Select"
                                  (change)="insuranceprovincelist($event)"
                                  [(ngModel)]="broker.stateFullDetails.shortName" [ngModelOptions]="{standalone: true}"
                                  [disabled]="isEditable|| enableEditIndex != i">
                                  <option value="">{{lang.Select}}</option>
                                  <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                                    {{ name.shortName }}
                                  </option>
                                </select>
                              </td>
                              <td>
                                <input type="text" placeholder="MM-DD-YYYY" class="form-control"
                                  [(ngModel)]="broker.expiryDate" [minDate]="todayDate"
                                  [ngModelOptions]="{standalone: true}" [disabled]="isEditable || enableEditIndex != i"
                                  bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}">
                              </td>
                              <td>
                                <input type="text" class="form-control checking-field" id="remainder_days"
                                  placeholder="Reminder Days" (keypress)="numberOnly($event)"
                                  [(ngModel)]="broker.reminderEmail" [ngModelOptions]="{standalone: true}"
                                  style="text-transform: capitalize;" [disabled]="isEditable || enableEditIndex != i" />
                              </td>
                              <td style="display: flex;margin-top:10px;">

                                <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                  data-bs-target="#basicModaledit" (click)="editadvisorlicenseDetails($event, i,broker)"
                                  *ngIf="enableEditIndex != i">
                                  <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                  class="btn btn-default deleteicon" (click)="deletelicense(broker,i)"
                                  *ngIf="enableEditIndex != i">
                                  <i class="bi bi-trash-fill"></i>
                                </button>

                                <!-- <button class="brokertablestatus"  data-bs-toggle="modal" data-bs-target="#basicModaledit" (click)="editadvisorlicenseDetails($event, i,broker)" *ngIf="enableEditIndex != i">Edit</button>&nbsp;
                        <button class="brokertablestatus" style="color:red" (click)="deletelicense(broker,i)" *ngIf="enableEditIndex != i">Delete</button> -->
                                <button class="brokertablestatus" style="color: green"
                                  *ngIf="!isEditable && enableEditIndex == i" (click)="saveLicense(broker, i)">
                                  {{lang.Save}}</button>&nbsp;
                                <button class="brokertablestatus" style="color: red"
                                  *ngIf="!isEditable && enableEditIndex == i" (click)="cancellicneseEdit($event, i)">
                                  {{lang.Cancel}}
                                </button>
                              </td>

                              <!-- <td style="text-align:right"><button class="btn btn-default editpencil" data-bs-toggle="modal" data-bs-target="#basicModaledit"(click)="editbrokerlicense(broker,i)"><i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button class="btn btn-default deleteicon" (click)="deletebrokerlicense(i)"><i class="bi bi-trash-fill"></i></button></td> -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <button class="btn btn-primary addgroupadmininfo" type="button" data-bs-toggle="modal"
                      data-bs-target="#basicModal1" (click)="addnewlicense()">
                      {{lang.Add_More}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- saletrackingcode -->

              <div *ngIf="salesTrackingCodeShares && salesTrackingCodeShares.length>0 && role=='ADMINISTRATOR'">

                <div class="row">
                  <div class="form-group col-12 mb-2">
                    <h6 class="admintitle">
                      <th>{{lang.Sales_Tracking_code}} &nbsp;&nbsp;<i class="bi bi-info-circle"></i></th>
                    </h6>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-12 mb-2">
                    <div style="direction: ltr; width: 100%">
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <table align="center">
                            <thead>
                              <tr>
                                <th>{{lang.Sales_Tracking_code}} </th>
                                <th>{{lang.Name}}</th>
                                <!-- <th>{{lang.Type}} </th> -->
                                <th>{{lang.Percentage}}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let sales of brokerProfileslist; let i = index"
                                [ngClass]="{ orange: i % 2 === 0, white: i % 2 !== 0 }">
                                <td title={{sales.additionalData.note}}>{{ sales.additionalData.code }} </td>
                                <td title={{sales.additionalData.note}}>
                                  {{ sales.name }}

                                </td>
                                <!-- <td>
                                  {{ sales.additionalData.code }}

                                </td> -->
                                <td>

                                  {{ sales.commission }}

                                </td>
                                <td class="text-center">
                                  <!-- <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                    data-bs-target="#salesTrackingEdit"
                                    (click)="editSaleslTrackingCode($event, i,sales)">
                                    <i class="bi bi-pencil-fill"></i>
                                  </button> -->
                                </td>

                              </tr>
                            </tbody>
                          </table>
                          <!-- <table align="center">
                            <thead>
                              <tr>
                                <th><th>{{lang.Sales_Tracking_code}} </th></th>
                                <th>{{lang.Name}}</th>
                                <th>{{lang.Type}} </th>
                                <th>{{lang.Percentage}}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let sales of salesTrackingCodeShares; let i = index"
                                [ngClass]="{ orange: i % 2 === 0, white: i % 2 !== 0 }">
                                <td>{{ sales.salesTrackingCode.code }}</td>
                                <td>
                                  <ng-container
                                    *ngFor="let salesdata of sales.salesTrackingCode.salesTrackingCodeShares">
                                    <div>{{ salesdata.broker.name }}</div>
                                  </ng-container>
                                </td>
                                <td>
                                  <ng-container
                                    *ngFor="let salesdata of sales.salesTrackingCode.salesTrackingCodeShares">
                                    <div>{{ salesdata.broker.brokerType }}</div>
                                  </ng-container>
                                </td>
                                <td>
                                  <ng-container
                                    *ngFor="let salesdata of sales.salesTrackingCode.salesTrackingCodeShares">
                                    <div class="text-start">{{ salesdata.percentage }}%</div>
                                  </ng-container>

                                </td>
                                <td class="text-center">
                                  <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                    data-bs-target="#salesTrackingEdit"
                                    (click)="editSaleslTrackingCode($event, i,sales)">
                                    <i class="bi bi-pencil-fill"></i>
                                  </button>
                                </td>

                              </tr>
                            </tbody>
                          </table> -->
                          <br>
                          <button class="btn btn-primary addgroupadmininfo" type="button" data-bs-toggle="modal"
                            data-bs-target="#BrokerSharedNewDetails" (click)="showBrokerDetails()">
                            {{lang.Add_More}}
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>



              <!-- {{lang.E_O_Information}} -->
              <div class="row">
                <div class="form-group col-12">
                  <h6 class="admintitle">
                    {{lang.E_O_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div>
              </div>

              <form class="onbordingform" [formGroup]="eoform" (ngSubmit)="addeo()" *ngIf="showEOForm">
                <div class="input-wrapper row">
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>

                    <input type="text" class="form-control checking-field" id="InsuranceName" placeholder={{lang.Insurer_Name}}
                      formControlName="insurerName" style="text-transform: capitalize" />

                    <div *ngIf="
                        eo['insurerName'].touched && eo['insurerName'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          eo['insurerName'].errors &&
                          eo['insurerName'].errors['required']
                        ">
                        {{lang.Please_enter_Insurance_name}}
                      </div>
                      <div *ngIf="
                          eo['insurerName'].errors &&
                          eo['insurerName'].errors['minlength']
                        ">
                        {{lang.Insurer_name_must_be_atleast_3_characters}}
                      </div>
                      <div *ngIf="
                          eo['insurerName'].errors &&
                          eo['insurerName'].errors['maxlength']
                        ">
                        {{lang.Insurer_name_must_not_exceed_100_characters}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
                    <input type="text" class="form-control checking-field" id="certificatename"
                      placeholder={{lang.Certificate}} formControlName="certificateNumber" />

                    <div *ngIf="
                        eo['certificateNumber'].touched &&
                        eo['certificateNumber'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          eo['certificateNumber'].errors &&
                          eo['certificateNumber'].errors['required']
                        ">
                        {{lang.Please_select_Certificate_Name}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

                    <input type="text" class="form-control checking-field" id="PolicyNumber" placeholder={{lang.Policy}}
                      formControlName="policyNumber" />

                    <div *ngIf="
                        eo['policyNumber'].touched && eo['policyNumber'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          eo['policyNumber'].errors &&
                          eo['policyNumber'].errors['required']
                        ">
                        {{lang.Please_enter_Policy_Number}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-wrapper row">
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

                    <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                      (onShown)="disableScrolling()" (onHidden)="enableScrolling()" [minDate]="todayDate" bsDatepicker
                      [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                    <div *ngIf="
                        eo['expiryDate'].touched && eo['expiryDate'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          eo['expiryDate'].errors &&
                          eo['expiryDate'].errors['required']
                        ">
                        {{lang.Please_select_expiry_date}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-4">
                    <!-- <button  type="submit" [hidden]="licenseform.invalid" class="btn btn-primary">Save</button> -->
                  </div>
                  <div class="form-group col-4">
                    <button type="submit" [hidden]="eoform.invalid" class="btn btn-primary addgroupadmininfo mt-5">Save
                    </button>
                  </div>
                </div>
              </form>

              <div class="row" *ngIf="!showEOForm">
                <div class="form-group col-12 mb-2">
                  <div style="overflow: auto; direction: ltr; width: 100%">
                    <table align="left">
                      <tr>
                        <th>{{lang.Insurer_Name}}</th>
                        <th>{{lang.Certificate}} #</th>
                        <th>{{lang.Policy}} #</th>
                        <th>{{lang.Expiry_Date}} </th>

                        <th></th>
                      </tr>
                      <tbody>
                        <tr *ngFor="
                            let broker of brokerEOinformation;
                            let i = index
                          " [ngClass]="{ orange: i % 2 == 0, white: i % 2 != 0 }">
                          <td>
                            <input type="text" class="form-control checking-field" id="insurerName"
                              [(ngModel)]="broker.insurerName" [ngModelOptions]="{ standalone: true }" [disabled]="
                                isEditableEO || enableEditIndexEO != i
                              " />
                          </td>
                          <td>
                            <input type="text" class="form-control" id="certificateNumber" placeholder="Select"
                              [disabled]="
                                isEditableEO || enableEditIndexEO != i
                              " [(ngModel)]="broker.certificateNumber" [ngModelOptions]="{ standalone: true }" />
                          </td>
                          <td>
                            <input type="text" class="form-control" id="policyNumber" placeholder="Select" [disabled]="
                                isEditableEO || enableEditIndexEO != i
                              " [(ngModel)]="broker.policyNumber" [ngModelOptions]="{ standalone: true }" />
                          </td>

                          <td>
                            <input type="text" placeholder="MM-DD-YYYY" class="form-control"
                              [disabled]="isEditableEO || enableEditIndexEO != i" [(ngModel)]="broker.expiryDate"
                              [minDate]="todayDate" [ngModelOptions]="{standalone: true}" bsDatepicker
                              [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}">
                          </td>

                          <td style="display: flex; margin-top: 10px">
                            <button class="btn btn-default editpencil" data-bs-toggle="modal"
                              data-bs-target="#basicModaleditEO" (click)="editadvisorEODetails($event, i, broker)"
                              *ngIf="enableEditIndexEO != i">
                              <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                              class="btn btn-default deleteicon" (click)="deleteEO(broker, i)"
                              *ngIf="enableEditIndexEO != i">
                              <i class="bi bi-trash-fill"></i>
                            </button>

                            <!-- <button class="brokertablestatus" data-bs-toggle="modal" data-bs-target="#basicModaleditEO" (click)="editadvisorEODetails($event,i,broker)" *ngIf="enableEditIndexEO != i">Edit</button>&nbsp;
                      <button class="brokertablestatus" style="color:red" (click)="deleteEO(broker,i)" *ngIf="enableEditIndexEO != i">Delete</button> -->
                            <button class="brokertablestatus" style="color: green"
                              *ngIf="!isEditableEO && enableEditIndexEO == i" (click)="saveEOInfo(broker, i)">
                              {{lang.Save}}</button>&nbsp;
                            <button class="brokertablestatus" style="color: red"
                              *ngIf="!isEditableEO && enableEditIndexEO == i" (click)="cancelEOEdit($event, i)">
                              {{lang.Cancel}}
                            </button>
                          </td>

                          <!-- <td style="text-align:right"><button class="btn btn-default editpencil" data-bs-toggle="modal" data-bs-target="#basicModaledit"(click)="editbrokerlicense(broker,i)"><i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button class="btn btn-default deleteicon" (click)="deletebrokerlicense(i)"><i class="bi bi-trash-fill"></i></button></td> -->
                        </tr>
                      </tbody>
                    </table>

                    <!-- <label  class="addgroupadmininfo" data-bs-toggle="modal" data-bs-target="#basicModal1" ><strong>{{lang.Add_More}}</strong></label> -->
                    <button *ngIf="addlicenseformtable" class="btn btn-primary addgroupadmininfo" type="button"
                      data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="hidegrpadmindetails()">
                      {{lang.Add_More}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- <div class="input-wrapper row">
                <div class="form-group col-4">
                  <label for="Corporation" class="Corporation">Insurance Name<span style="color: red">*</span></label>

                  <input
                  type="text"
                  class="form-control checking-field"
                  id="InsuranceName"
                  placeholder="Name"
                  formControlName="InsuranceName"  style="text-transform: capitalize;"/>

                <div *ngIf="broker['InsuranceName'].touched && broker['InsuranceName'].invalid" class="help-block text-danger">
                  <div *ngIf="broker['InsuranceName'].errors && broker['InsuranceName'].errors['required']">{{lang.Please_enter_Insurance_name}}</div>
                </div>

                </div>
                <div class="form-group col-4">
                  <label for="Corporation" class="Corporation">{{lang.Policy}} #<span style="color: red">*</span></label>

                  <input
                  type="text"
                  class="form-control checking-field"
                  id="PolicyNumber"
                  placeholder="Policy Number"
                  formControlName="policyNumber"/>


                <div *ngIf="broker['policyNumber'].touched && broker['policyNumber'].invalid" class="help-block text-danger">
                  <div *ngIf="broker['policyNumber'].errors && broker['policyNumber'].errors['required']">{{lang.Please_enter_Policy_Number}}</div>

                </div>
                </div>
                <div class="form-group col-4">
                  <label for="Corporation" class="Corporation">{{lang.Certificate}} #<span style="color: red">*</span></label>

                  <input
                  type="text"
                  class="form-control checking-field"
                  id="certificatename"
                  placeholder="Certificate Name"
                  formControlName="certificateName"/>


                <div *ngIf="broker['certificateName'].touched && broker['certificateName'].invalid" class="help-block text-danger">
                  <div *ngIf="broker['certificateName'].errors && broker['certificateName'].errors['required']">Please select Certificate Name</div>

                </div>
                </div>
              </div>
              <div class="input-wrapper row">
                <div class="form-group col-4">
                  <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>

                  <input type="text"
                  placeholder="Expiry Date"
                  class="form-control"

                  formControlName="Insuranceexpiry"
                  bsDatepicker
                  [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }">
                  <div *ngIf="broker['Insuranceexpiry'].touched && broker['Insuranceexpiry'].invalid" class="help-block text-danger">
                    <div *ngIf="broker['Insuranceexpiry'].errors && broker['Insuranceexpiry'].errors['required']">{{lang.Please_select_expiry_date}} </div>



                  </div>

                </div>

              </div> -->

              <!-- <div class="row">
                  <div class="form-group col-3">
              <h6 class="admintitle">Use Parent Logo?&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6>

                <div class="form-check form-check-inline">
                  <input  type="radio" name="parentlogo" id="parentlogoyes" value=true formControlName="parentlogo" (change)="checkParentlogo($event)">
                  <label  for="parentlogoyes" class="parentlogo">&nbsp;&nbsp;Yes</label>
                </div>
                <div class="form-check form-check-inline">
                  <input  type="radio" name="parentlogo" id="parentlogono" value=false formControlName="parentlogo" (change)="checkParentlogo($event)">
                  <label  for="parentlogono" class="parentlogo">&nbsp;&nbsp;No</label>
                </div>


                <div *ngIf="broker['parentlogo'].touched && broker['parentlogo'].invalid" class="help-block text-danger">
                  <div *ngIf="broker['parentlogo'].errors && broker['parentlogo'].errors['required']">Please select parentlogo configuration</div>

                </div>
                <div class="clearfix"></div>
                </div>
                <div class="form-group col-3"  *ngIf="showparentlogocondition">
                  <h6 class="admintitle">Logo&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>

                    <div class="uploadCorporateLogo">

                      <label for="adminlogo" class="adminlogo">
                      <span *ngIf="showimagelogo">
                       <p style="font-size:12px;"> Click to upload
                        <br>
                         LOGO
                        <br>
                        Max. 300x100 px .png,.jpg </p>
                      </span>
                        <img [src]="imagedisplay" style="max-height: 50px">
                      </label>
                      <input id="adminlogo" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo($event)">

                    </div>



                </div>
                <div class="form-group col-3">
                  <h6 class="admintitle">Use Parent Disclosure?&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6>

                    <div class="form-check form-check-inline">
                      <input  type="radio" name="parentdisclosure" id="parentdisclosureyes" value=true formControlName="parentdisclosure" (change)="checkParentdisclosure($event)">
                      <label  for="parentdisclosureyes" class="parentlogo">&nbsp;&nbsp;Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input  type="radio" name="parentdisclosure" id="parentdisclosureno" value=false formControlName="parentdisclosure" (change)="checkParentdisclosure($event)">
                      <label  for="parentdisclosureno" class="parentlogo">&nbsp;&nbsp;No</label>
                    </div>


                    <div *ngIf="broker['parentdisclosure'].touched && broker['parentdisclosure'].invalid" class="help-block text-danger">
                      <div *ngIf="broker['parentdisclosure'].errors && broker['parentdisclosure'].errors['required']">Please select parentdisclosure</div>

                    </div>
                    <div class="clearfix"></div>
                    </div>
                <div class="form-group col-3" *ngIf="showparentdisclosurecondition">
                  <h6 class="admintitle">Disclosure Agreement&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>

                    <div class="uploadCorporateLogo">

                      <label for="Disclosure" class="Disclosure">
                      <span *ngIf="showdisclosureaggrement">
                       <p style="font-size:12px;"> Click to upload
                        <br>
                        Disclosure Agreement
                    </p>
                      </span>
                        <img [src]="imagedisplaypdf" style="max-height: 50px">
                      </label>
                      <input id="Disclosure" type="file"  style="display: none;" formControlName="disclosureAgreement" (change)="uploadadmindisclosure($event)">

                    </div>
                    <div *ngIf="broker['disclosureAgreement'].touched && broker['disclosureAgreement'].invalid" class="help-block text-danger">
                      <div *ngIf="broker['disclosureAgreement'].errors && broker['disclosureAgreement'].errors['required']">Please upload disclosureAgreement</div>

                    </div>
                </div>
                </div> -->

              <div class="row">
                <div class="form-group col-12">
                  <!-- <h6 class="admintitle">Do you want to Create Signup Form?&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6> -->

                  <h6 class="admintitle">
                    Enrollment Form Information&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>


                </div>
              </div>

              <div class="row">
                <div class="form-group col-12">
                  <div style="direction: ltr; width: 100%">
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <table align="left" *ngIf="showFormsDetails">
                          <tr>
                            <th>{{lang.Type}} </th>
                            <th>{{lang.Profile}} </th>
                            <th>{{lang.Title}} </th>
                            <th>{{lang.Description}} </th>
                            <th>{{lang.Logo}} </th>
                            <th>{{lang.Link}} </th>
                            <th></th>
                            <th></th>
                          </tr>
                          <tbody>

                            <tr *ngFor="
                                let broker of brokerFormData;
                                let i = index
                              " [ngClass]="{
                                orange: i % 2 == 0,
                                white: i % 2 != 0
                              }">
                              <td>
                                <select class="form-control" id="Signupformtype" placeholder="Select"
                                  [(ngModel)]="broker.formType" [ngModelOptions]="{ standalone: true }" [disabled]="
                                    isEditableForm || enableEditIndexForm != i
                                  " (change)="selectFormname($event)">
                                  <option value="">{{lang.Select}}</option>
                                  <option *ngFor="let name of formType" [value]="name.label">
                                    {{ name.display }}
                                  </option>
                                </select>
                              </td>
                              <td title={{broker.profile}}>
                                <select class="form-control" id="SignupformtypeDataaa" placeholder="Select"
                                  [(ngModel)]="broker.matchedProfile.originalBrokerId"
                                  [ngModelOptions]="{ standalone: true }">
                                  <option [value]="" disabled>Select</option>
                                  <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                                    {{profile.name}}({{profile.additionalData.statement}})
                                  </option>
                                </select>

                                <!-- <input type="text" class="form-control checking-field" id="FormName"
                                placeholder="formName" [(ngModel)]="broker.matchedProfile.originalBrokerId"
                                [ngModelOptions]="{ standalone: true }" style="text-transform: capitalize" [disabled]="
                                  isEditableForm || enableEditIndexForm != i
                                " /> -->
                              </td>
                              <td>
                                <input type="text" class="form-control checking-field" id="FormName"
                                  placeholder="formName" [(ngModel)]="broker.name"
                                  [ngModelOptions]="{ standalone: true }" style="text-transform: capitalize" [disabled]="
                                    isEditableForm || enableEditIndexForm != i
                                  " />
                              </td>
                              <td>
                                <input type="text" class="form-control checking-field" id="Description"
                                  placeholder="Description" [(ngModel)]="broker.description"
                                  [ngModelOptions]="{ standalone: true }" style="text-transform: capitalize" [disabled]="
                                    isEditableForm || enableEditIndexForm != i
                                  " />
                              </td>
                              <td>
                                <img [src]="broker.logo||'/assets/img/logo.png'"
                                  style="max-height: 50px;max-width: 100px;" />
                              <td>
                                <input type="text" class="form-control1" value="{{ broker.link }}" #inputTarget />
                              </td>
                              <td>
                                <button class="copyButton" (click)="copylink()" [ngxClipboard]="inputTarget">
                                  {{lang.Copy}}
                                </button>
                              </td>

                              <td style="display: flex; margin-top: 10px">
                                <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                  (click)="
                                    editadvisorformDetails($event, i, broker)
                                  " *ngIf="enableEditIndexForm != i">
                                  <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                  class="btn btn-default deleteicon" (click)="deleteForm(broker, i)"
                                  *ngIf="enableEditIndexForm != i">
                                  <i class="bi bi-trash-fill"></i>
                                </button>

                                <!-- <button class="brokertablestatus" data-bs-toggle="modal" data-bs-target="#basicModalFormedit" (click)="editadvisorformDetails($event, i,broker)" *ngIf="enableEditIndexForm != i">Edit</button>&nbsp;
                          <button class="brokertablestatus" style="color:red" (click)="deleteForm(broker,i)" *ngIf="enableEditIndexForm != i">Delete</button> -->
                                <button class="brokertablestatus" style="color: green" *ngIf="
                                    !isEditableForm && enableEditIndexForm == i
                                  " (click)="saveForm(broker, i)">
                                  {{lang.Save}}</button>&nbsp;
                                <button class="brokertablestatus" style="color: red" *ngIf="
                                    !isEditableForm && enableEditIndexForm == i
                                  " (click)="cancelFormEdit($event, i)">
                                  {{lang.Cancel}}
                                </button>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>

                    <button *ngIf="showFormsDetails" class="btn btn-primary addgroupadmininfo" type="button"
                      data-bs-toggle="modal" (click)="addextraform()">
                      {{lang.Add_More}}
                    </button>
                  </div>
                </div>
              </div>
              <form class="onbordingform" [formGroup]="formCreation" (ngSubmit)="addform()" *ngIf="showaddform">
                <div class="input-wrapper row">

                  <div class="form-group col-4">
                    <!-- <label for="Corporation" class="Corporation">{{lang.Select_Profile_for_signup}}<span -->
                    <label for="Corporation" class="Corporation">Select Profile for enrollment<span
                        style="color: red">*</span></label>
                    <select class="form-control select2" id="parentidrole" placeholder="Select"
                      formControlName="profileName" data-live-search="true" (change)="getProfilebasedid($event)">
                      <option value="" selected>Select</option>
                      <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                        {{profile.name}}({{profile.additionalData.statement}})
                      </option>
                    </select>

                    <div *ngIf="form['profileName'].touched && form['profileName'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="form['profileName'].errors &&form['profileName'].errors['required']">
                        {{lang.Please_select_profile}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-wrapper row">


                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
                    <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                      [(ngModel)]="formTitle" formControlName="formName" style="text-transform: capitalize"
                      (change)="checkformExist()" />
                  </div>
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
                    <input type="text" class="form-control checking-field" id="formDescription"
                      placeholder={{lang.Description}} [(ngModel)]="formDescription" formControlName="formDescription"
                      style="text-transform: capitalize" />
                  </div>
                  <div class="form-group col-4">
                    <label for="Corporation" class="Corporation">{{lang.Logo}}</label>
                    <input type="file" class="form-control checking-field" id="formlogo" placeholder="logog"
                      formControlName="formlogo" />
                  </div>
                </div>

                <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
                  style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;" *ngIf="showPlans">

                  <app-common-plans
                    #newAdvisorAdd
                    [isAdvisor]="true"
                    [viewPlan]="false"
                    [advisorPackages]="productsArray"
                    [allplansArray]="allplansArray"
                    (submitTriggered)="addformDuplicate()"
                    [editFormPricingOptions]=""
                    [selectedPlanLevels]="[]"
                    >
                  </app-common-plans>

                  <ng-container *ngIf="false">
                  <div *ngFor="let product of productsArray; let i=index" class="mt-2">

                    <div class="display-center">
                      <div
                        class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                        style="width:430px;"
                        [ngStyle]="{ 'background-color': product.published ? '#515151' : '#dc3545' }">

                        <span class="my-auto col-1 ">
                          <input type="checkbox" id="package{{product.id}}"
                            [disabled]="allplansArray[product.name]?.disabled===true"
                            [checked]="allplansArray[product.name]?.packageCheckbox===true"
                            (change)="toggleAllPlans(product.name,product.id, $event)" />
                        </span>
                        <div class="my-auto mb-1 col-10 text-center">
                          <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                              *ngIf="!product.published && role==='ADMINISTRATOR'" class="bi bi-info-circle text-light "
                              title="Unpublished"></i></span>
                        </div>
                        <div *ngIf="role==='ADMINISTRATOR'"
                          title="{{getTextForTooltip1(product.published,product.restrict)}}"
                          [ngStyle]=" { 'border-color' : getColorForPlans1(product.published,product.restrict) }"
                          class="outer my-auto ms-3 col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans1(product.published,product.restrict) }"></span>
                        </div>
                      </div>
                    </div>

                    <div class="display-center mt-3 mb-4 flex-wrap">
                      <div *ngFor="let plans of product.parents| keyvalue; let k=index">
                        <div
                          class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                          *ngIf="isParentsGreaterThanOne(product.parents)"
                          style="background-color: #515151; width:210px">

                          <span class="my-auto col-1">
                            <input type="checkbox" [disabled]="allplansArray[product.name][plans.key]?.disabled===true"
                              [checked]="allplansArray[product.name][plans.key]?.checked===true"
                              (change)="planKeyCheckbox(product.name,plans.key,plans.value[0].parentId,$event)" />
                          </span>
                          <span class="my-auto mb-1 col-9 text-center">{{ plans.key }}</span>
                        </div>
                        <div
                          [ngClass]="{'display-center': !isParentsGreaterThanOne(product.parents), 'flex-wrap': !isParentsGreaterThanOne(product.parents)}">
                          <div *ngFor="let plan of plans.value">
                            <div [style.background-color]="plan.backgroundColor ? plan.backgroundColor : '#5E152E'"
                              class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex
                                              align-items-center gap-1 row py-1 rounded" style="width:210px ">
                              <!-- *ngIf="plan.parentId != null" -->
                              <div class="my-auto col-1">
                                <input type="checkbox" id="planCheckbox{{plan.id}}"
                                  [checked]="allplansArray[product.name][plan.name]?.planCheckbox===true"
                                  [disabled]="allplansArray[product.name][plan.name]?.disabled===true"
                                  (change)="planCheckbox(product.name,plans.key,plans.value[0].parentId,plan.name,plan.id,$event)" />
                              </div>
                              <div class="my-auto col-9 mb-1  " style="font-size:12px">
                                <span>{{ plan.name }}</span>

                              </div>
                              <div *ngIf="role==='ADMINISTRATOR'"
                                title="{{getTextForTooltip(plan.published.data[0],plan.restrict)}}"
                                [ngStyle]=" { 'border-color' : getColorForPlans(plan.published.data[0],plan.restrict) }"
                                class="outer my-auto col-2" data-bs-toggle="">
                                <span class="inner"
                                  [ngStyle]="{ 'background': getColorForPlans(plan.published.data[0],plan.restrict) }"></span>
                              </div>

                            </div>
                            <div class="mt-2 mx-1" *ngIf="showPricing && plan.id==5">
                              <label class="Corporation">{{lang.Pricing }}</label>
                              <select type="" class="form-control1 py-1 text-dark" id="pricingOptions"
                                placeholder="Select" (change)="selectPricingOptions" formControlName="pricingOptions">
                                <option selected value="">{{lang.Select}}</option>
                                <option *ngFor="let option of pricingOptions" [value]="option.key">
                                  {{ option.display }}
                                </option>
                              </select>
                            </div>
                            <div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <hr style="    height: 2px;
                                    background-color: black;">
                  </div>
                  </ng-container>
                  <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
                    {{lang.Please_select_atleast_one_plan}}
                  </div>

                  <div class="row mt-2 mb-2">
                  <div class="form-group col-8"></div>
                    <div class="form-group col-4">
                      <button style="font-size:12px"
                        class="btn btn-primary p-0 py-1 px-2" (click)="newAdvisorAdd.addForm()">
                        {{lang.Save}}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </form>

            <br />
            <br />

            <div class="d-flex justify-content-between">
              <button class="saveAndNext" id="backbuttonForm" type="button" (click)="gotoadvsiorpage()">
                <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Previous
              </button>
              <div>
                <div *ngIf="saveError" class="text-danger text-end" style="font-size:12px">
                  <!-- {{lang.Please_save_signup_form}} -->
                  Please save enrollment form
                </div>
                <button class="saveAndNext  glow-on-hover" id="basicformSubmit" type="button"
                  (click)="submitbasicInfo()">
                  {{lang.Save}}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-2 actionspage">
        <div class="row">
          <div class="form-group col-12">
            <!-- <h6 class="actionsrequired">Welcome {{ adminName | titlecase }}</h6> -->
            <h6 class="actionsrequired text-center">{{lang.Notifications}}</h6>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<!-- {{lang.Edit_Group_Contact}} -->

<div class="modal fade" id="basicModaleditgroupcontact" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}}
                (change)="phoneFormatForGroupCont(adminform, 'phoneNum')" formControlName="phoneNum" />

              <div *ngIf="
                  grpcontact['phoneNum'].touched &&
                  grpcontact['phoneNum'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                 {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>

              <select (change)="groupContactChange($event)" class="form-control" id="lengthofService"
                formControlName="role" name="adminrole">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
              </select>
              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="form-group col-6" *ngIf="ShowOthers">
              <!-- <div> -->
              <label for="Corporation" class="Corporation">{{lang.Others}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="roleName" placeholder="Others"
                formControlName="roleName" />
              <div *ngIf="
                  grpcontact['roleName'].touched &&
                  grpcontact['roleName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['roleName'].errors &&
                    grpcontact['roleName'].errors['required']
                  ">
                  {{lang.please_enter_role}}
                </div>

                <!-- </div> -->
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editadminSubmit(adminform)">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- {{lang.Add_Group_Contact}} -->

<div class="modal fade" id="basicModaladdgrpcontact" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && grpcontact['firstName'].errors" class="invalid-feedback">
                <div *ngIf="grpcontact['firstName'].errors['required']">First Name is required</div>
                <div *ngIf="grpcontact['firstName'].errors['minlength']">
                  First Name must be at least 3 characters
                </div>
                <div *ngIf="grpcontact['firstName'].errors['maxlength']">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span  style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}}
                (change)="phoneFormatForGroupCont(adminform, 'phoneNum')" formControlName="phoneNum" />

              <div *ngIf="
                  grpcontact['phoneNum'].touched &&
                  grpcontact['phoneNum'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <!-- <div *ngIf="grpcontact['phoneNum'].errors && grpcontact['phoneNum'].errors['pattern']">Please enter valid phone number</div> -->
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                 {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>
              <select (change)="groupContactChange($event)" class="form-control" id="lengthofService"
                formControlName="role">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
              </select>
              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="form-group col-6" *ngIf="ShowOthers">
              <!-- <div> -->
              <label for="Corporation" class="Corporation">{{lang.Others}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="roleName" placeholder="Others"
                formControlName="roleName" />
              <div *ngIf="
                  grpcontact['roleName'].touched &&
                  grpcontact['roleName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['roleName'].errors &&
                    grpcontact['roleName'].errors['required']
                  ">
                  {{lang.please_enter_role}}
                </div>

                <!-- </div> -->
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="adminform.invalid" (click)="addadmin()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<!-- Model For {{lang.Add_Broker_License}} -->
<div class="modal fade" id="basicModal1" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Broker_License}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNumber" style="text-transform: capitalize" />

              <div *ngIf="f['licenseNumber'].touched && f['licenseNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverage" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  Please select state
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>

              <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                (keypress)="numberOnly($event)" formControlName="remainder_days" style="text-transform: capitalize" />

              <div *ngIf="
                  f['remainder_days'].touched && f['remainder_days'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['remainder_days'].errors &&
                    f['remainder_days'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hideaddlicenseform()">
          Close
        </button>
        <button type="button" class="btn btn-primary" [disabled]="licenseform.invalid" (click)="addlicense()">
          Save
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<!-- Model For add extra profiles to broker -->

<!-- Model For Edit broker  license -->
<div class="modal fade" id="basicModaledit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Edit License</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder="Number"
                formControlName="licenseNumber" [(ngModel)]="editbrokerlicensenumber"
                style="text-transform: capitalize" />

              <div *ngIf="f['licenseNumber'].touched && f['licenseNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">Coverage<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage"
                [(ngModel)]="editbrokerlicensecoverage">
                <option value="" disabled>{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverage" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                [(ngModel)]="editbrokerlicensestate" (change)="insuranceprovincelist($event)">
                <option value="" disabled>{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  Please enter State
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>


              <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                [minDate]="todayDate" [(ngModel)]="editbrokerlicenseexpirydate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}">
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="f['expiryDate'].errors && f['expiryDate'].errors['required']">{{lang.Please_select_expiry_date}}
                </div>



              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder="Reminder Days"
                [(ngModel)]="editbrokerlicenseexpiryremainder" (keypress)="numberOnly($event)"
                formControlName="remainder_days" style="text-transform: capitalize;" />


              <div *ngIf="f['remainder_days'].touched && f['remainder_days'].invalid" class="help-block text-danger">
                <div *ngIf="f['remainder_days'].errors && f['remainder_days'].errors['required']">Please enter reminder
                  days</div>

              </div>
            </div>

          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="hideaddlicenseform()">Close</button>
        <button type="button" class="btn btn-primary" (click)="editLicenseSubmit()">Save</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="salesTrackingEdit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Sales_TrackingCode}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeEditSalesTrackingCodes()"></button>
      </div>
      <div class="modal-body">

        <div class="mx-2 row">
          <div class="col-5"><th>{{lang.Sales_Tracking_code}} </th> </div>
          <div class=" col-5 salecode px-1 py-1">{{salesTrackingCode}}</div>
        </div>
        <div class="row salescracking mt-2 mx-2">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>{{lang.broker}}</th>
                <th>{{lang.Percentage}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dynamic of brokersalesCodes; let i = index">
                <td>
                  <select class="form-control select2" id="parentidrole" placeholder="Select"
                    name="{{ dynamic.brokerId }}" [(ngModel)]="dynamic.brokerId" [ngModelOptions]="{ standalone: true }"
                    data-live-search="true">
                    <option value="" label="" disabled>{{lang.Select}}</option>
                    <option *ngFor="let broker of allBrokers" [value]="broker.id">
                      {{ broker.name }}-{{ broker.brokerType }}-{{
                      broker.salesTrackingCode
                      }}
                    </option>
                  </select>
                </td>
                <td>
                  <input class="form-control" name="{{ dynamic.percentage }}" [(ngModel)]="dynamic.percentage"
                    [ngModelOptions]="{ standalone: true }" type="number" maxlength="3" placeholder="" />
                </td>
                <td>
                  <button class="fa fa-trash-o deletetier" style="cursor: pointer;" [disabled]="i === 0"
                    (click)="deleteRow(i, dynamic)"></button>
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
          <br>
          <div class="form-group text-end p-0">
            <button class="btn btn-primary addgroupadmininfo" type="button" (click)="addRow()">
              {{lang.Add_More}}
            </button>

          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" data-bs-dismiss="modal" (click)="closeEditSalesTrackingCodes()">Close</button>
        <button type="button" class=" saveAndNext" (click)="saveEditSalesTrackingCodes()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Model For Add Form Details -->
<div class="modal fade" id="addFormDetails" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 1200px; margin-left: -325px" *ngIf="showaddplans">
      <div class="modal-header">
        <!-- <h6 class="modal-title">{{lang.Add_Signup_Form}}</h6> -->
        <h6 class="modal-title">Add Enrollment Form</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closePlans()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="formCreation">
          <div class="input-wrapper row">
            <!-- <div class="form-group col-4">
              <label for="Corporation" class="Corporation">Type<span style="color: red">*</span></label>
              <select class="form-control" id="Signupformtype" placeholder="Select" formControlName="Signupformtype"
                (change)="selectFormname($event)">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of formType" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  form['Signupformtype'].touched &&
                  form['Signupformtype'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['Signupformtype'].errors &&
                    form['Signupformtype'].errors['required']
                  ">
                  Please select type
                </div>
              </div>
            </div> -->
            <div class="input-wrapper row">

              <div class="form-group col-4">
                <!-- <label for="Corporation" class="Corporation">{{lang.Select_Profile_for_signup}}<span -->
                <label for="Corporation" class="Corporation">Select Profile for enrollment<span
                    style="color: red">*</span></label>
                <select class="form-control select2" id="parentidrole" placeholder="Select"
                  formControlName="profileName" data-live-search="true" (change)="getProfilebasedid($event)">
                  <option value="" selected>Select</option>
                  <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                    {{profile.name}}({{profile.additionalData.statement}})
                  </option>
                </select>

                <div *ngIf="
                                    form['profileName'].touched && form['profileName'].invalid
                                  " class="help-block text-danger">
                  <div *ngIf="
                                      form['profileName'].errors &&
                                      form['profileName'].errors['required']
                                    ">
                    {{lang.Please_select_profile}}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formName" placeholder="Title"
                formControlName="formName" style="text-transform: capitalize" />

              <div *ngIf="form['formName'].touched && form['formName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formName'].errors &&
                    form['formName'].errors['required']
                  ">
                  {{lang.Please_enter_form_title}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formDescription" placeholder="Description"
                formControlName="formDescription" style="text-transform: capitalize" />

              <div *ngIf="
                  form['formDescription'].touched &&
                  form['formDescription'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['formDescription'].errors &&
                    form['formDescription'].errors['required']
                  ">
                  {{lang.Please_enter_form_description}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Logo}}</label>
              <input type="file" class="form-control checking-field" id="formlogo" placeholder="logo"
                formControlName="formlogo" (change)="uploadadminFormlogo($event)" />

              <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
                <div *ngIf="
                                form['formlogo'].errors &&
                                form['formlogo'].errors['required']
                              ">
                  {{lang.Please_choose_form_logo}}
                </div>
              </div>
            </div>
          </div>

          <app-common-plans
            #advisorAdd
            [isAdvisor]="true"
            [viewPlan]="false"
            [advisorPackages]="productsArray"
            [allplansArray]="allplansArray"
            (submitTriggered)="addform()"
            [editFormPricingOptions]=""
            [selectedPlanLevels]="[]"
            >
          </app-common-plans>

          <ng-container *ngIf="false">
          <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
            style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;" *ngIf="showPlans">

            <div *ngFor="let product of productsArray; let i=index" class="mt-2">

              <div class="display-center">
                <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                  style="width:430px;" [ngStyle]="{ 'background-color': product.published ? '#515151' : '#dc3545' }">

                  <span class="my-auto col-1 ">
                    <input type="checkbox" id="package{{product.id}}"
                      [disabled]="allplansArray[product.name]?.disabled===true"
                      [checked]="allplansArray[product.name]?.packageCheckbox===true"
                      (change)="toggleAllPlans(product.name,product.id, $event)" />
                  </span>
                  <div class="my-auto mb-1 col-10 text-center">
                    <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                        *ngIf="!product.published && role==='ADMINISTRATOR'" class="bi bi-info-circle text-light "
                        title="Unpublished"></i></span>
                  </div>
                  <div *ngIf="role==='ADMINISTRATOR'" title="{{getTextForTooltip1(product.published,product.restrict)}}"
                    [ngStyle]=" { 'border-color' : getColorForPlans1(product.published,product.restrict) }"
                    class="outer my-auto ms-3 col-2" data-bs-toggle="">
                    <span class="inner"
                      [ngStyle]="{ 'background': getColorForPlans1(product.published,product.restrict) }"></span>
                  </div>
                </div>
              </div>

              <div class="display-center mt-3 mb-4 flex-wrap">
                <div *ngFor="let plans of product.parents| keyvalue; let k=index">
                  <div
                    class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                    *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width:210px">

                    <span class="my-auto col-1">
                      <input type="checkbox" [disabled]="allplansArray[product.name][plans.key]?.disabled===true"
                        [checked]="allplansArray[product.name][plans.key]?.checked===true"
                        (change)="planKeyCheckbox(product.name,plans.key,plans.value[0].parentId,$event)" />
                    </span>
                    <span class="my-auto mb-1 col-9 text-center">{{ plans.key }}</span>
                  </div>
                  <div
                    [ngClass]="{'display-center': !isParentsGreaterThanOne(product.parents), 'flex-wrap': !isParentsGreaterThanOne(product.parents)}">
                    <div *ngFor="let plan of plans.value">
                      <div [style.background-color]="plan.backgroundColor ? plan.backgroundColor : '#5E152E'" class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex
                                          align-items-center gap-1 row py-1 rounded" style="width:210px ">
                        <!-- *ngIf="plan.parentId != null" -->
                        <div class="my-auto col-1">
                          <input type="checkbox" id="planCheckbox{{plan.id}}"
                            [checked]="allplansArray[product.name][plan.name]?.planCheckbox===true"
                            [disabled]="allplansArray[product.name][plan.name]?.disabled===true"
                            (change)="planCheckbox(product.name,plans.key,plans.value[0].parentId,plan.name,plan.id,$event)" />
                        </div>
                        <div class="my-auto col-9 mb-1  " style="font-size:12px">
                          <span>{{ plan.name }}</span>

                        </div>
                        <div *ngIf="role==='ADMINISTRATOR'"
                          title="{{getTextForTooltip(plan.published.data[0],plan.restrict)}}"
                          [ngStyle]=" { 'border-color' : getColorForPlans(plan.published.data[0],plan.restrict) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans(plan.published.data[0],plan.restrict) }"></span>
                        </div>

                      </div>
                      <div class="mt-2 mx-1" *ngIf="showPricing && plan.id==5">
                        <label class="Corporation">{{lang.Pricing }}</label>
                        <select type="" class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                          (change)="selectPricingOptions" formControlName="pricingOptions">
                          <option selected value="">{{lang.Select}}</option>
                          <option *ngFor="let option of pricingOptions" [value]="option.key">
                            {{ option.display }}
                          </option>
                        </select>
                      </div>
                      <div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <hr style="    height: 2px; background-color: black;">
            </div>
          </div>
          </ng-container>
          <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
            {{lang.Please_select_atleast_one_plan}}
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="resetFormCreation()">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="addform()">
          {{lang.Save}}
        </button> -->
        <ng-container *ngIf="showaddplans">
          <button type="button" class="btn btn-primary" [disabled]="formCreation?.invalid" (click)="advisorAdd.addForm()">
            {{lang.Save}}
          </button>
        </ng-container>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<!-- Model For Edit form Details -->
<div class="modal fade" id="basicModalFormedit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 1200px; margin-left: -325px" *ngIf="showeditplans">
      <div class="modal-header">
        <!-- <h6 class="modal-title">{{lang.Edit_Signup_Form_Details}}</h6> -->
        <h6 class="modal-title">Edit Enrollment Form Details</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closePlans()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="formCreation" (ngSubmit)="addform()">
          <div class="input-wrapper row">

            <div class="form-group col-4">
              <!-- <label for="Corporation" class="Corporation">{{lang.Select_Profile_for_signup}}<span -->
              <label for="Corporation" class="Corporation">Select Profile for enrollment<span
                  style="color: red">*</span></label>
              <select class="form-control select2" id="parentidrole" placeholder="Select" [(ngModel)]="editFormProfile"
                formControlName="profileName" data-live-search="true" (change)="getProfilebasedid($event)">
                <option value="" selected>Select</option>
                <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                  {{profile.name}}({{profile.additionalData.statement}})
                </option>
              </select>

              <div *ngIf="
                                  form['profileName'].touched && form['profileName'].invalid
                                " class="help-block text-danger">
                <div *ngIf="
                                    form['profileName'].errors &&
                                    form['profileName'].errors['required']
                                  ">
                  {{lang.Please_select_profile}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                [(ngModel)]="editFormName" formControlName="formName" style="text-transform: capitalize" />
              <div *ngIf="form['formName'].touched && form['formName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formName'].errors &&
                    form['formName'].errors['required']
                  ">
                  {{lang.Please_enter_form_title}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formDescription" placeholder={{lang.Description}}
                [(ngModel)]="editFormDescription" formControlName="formDescription"
                style="text-transform: capitalize" />
              <div *ngIf="
                  form['formDescription'].touched &&
                  form['formDescription'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['formDescription'].errors &&
                    form['formDescription'].errors['required']
                  ">
                  {{lang.Please_enter_form_description}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Logo}}
              </label>

              <div class="uploadCorporateLogo" *ngIf="editFormlogo && editFormlogo.length > 0; else showLogo">
                <label for="adminformlogo" class="adminformlogo">
                  <img [src]="editFormlogo" style="max-height: 50px ;max-width:100px" />
                </label>
                <input id="adminformlogo" class="form-control checking-field" style="display: none" type="file"
                  accept="image/*" formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
              </div>
              <ng-template #showLogo>
                <input id="adminformlogo" class="form-control checking-field" type="file" accept="image/*"
                  formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
              </ng-template>
              <div class="text-end" style="font-size:10px">{{lang.Click_to_update_logo}}</div>
            </div>
            <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
              <div *ngIf="form['formlogo'].errors && form['formlogo'].errors['required']">
                {{lang.Please_choose_form_logo}}
              </div>
            </div>

          </div>

          <app-common-plans
            #advisor
            [isAdvisor]="true"
            [viewPlan]="false"
            [advisorPackages]="productsArray"
            [allplansArray]="allplansArray"
            [selectedPlanLevels]="selectedPlanLevels"
            [editFormPricingOptions]="editFormPricingOptions"
            (submitTriggered)="editFormSubmit()"
          >
          </app-common-plans>

          <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
            style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;" *ngIf="showPlans && false">

            <div *ngFor="let product of productsArray; let i=index" class="mt-2">

              <div class="display-center">
                <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                  style="width:430px;" [ngStyle]="{ 'background-color': product.published ? '#515151' : '#dc3545' }">

                  <span class="my-auto col-1 ">
                    <input type="checkbox" id="package{{product.id}}"
                      [disabled]="allplansArray[product.name]?.disabled===true"
                      [checked]="allplansArray[product.name]?.packageCheckbox===true"
                      (change)="toggleAllPlans(product.name,product.id, $event)" />
                  </span>
                  <div class="my-auto mb-1 col-10 text-center">
                    <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                        *ngIf="!product.published && role==='ADMINISTRATOR'" class="bi bi-info-circle text-light "
                        title="Unpublished"></i></span>
                  </div>
                  <div *ngIf="role==='ADMINISTRATOR'" title="{{getTextForTooltip1(product.published,product.restrict)}}"
                    [ngStyle]=" { 'border-color' : getColorForPlans1(product.published,product.restrict) }"
                    class="outer my-auto ms-3 col-2" data-bs-toggle="">
                    <span class="inner"
                      [ngStyle]="{ 'background': getColorForPlans1(product.published,product.restrict) }"></span>
                  </div>


                </div>
              </div>

              <div class="display-center mt-3 mb-4 flex-wrap">
                <div *ngFor="let plans of product.parents| keyvalue; let k=index">
                  <div
                    class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                    *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width:210px">

                    <span class="my-auto col-1">
                      <input type="checkbox" [disabled]="allplansArray[product.name][plans.key]?.disabled===true"
                        [checked]="allplansArray[product.name][plans.key]?.checked===true"
                        (change)="planKeyCheckbox(product.name,plans.key,plans.value[0].parentId,$event)" />
                    </span>
                    <span class="my-auto mb-1 col-9 text-center">{{ plans.key }}</span>
                  </div>
                  <div
                    [ngClass]="{'display-center': !isParentsGreaterThanOne(product.parents), 'flex-wrap': !isParentsGreaterThanOne(product.parents)}">
                    <div *ngFor="let plan of plans.value">
                      <div [style.background-color]="plan.backgroundColor ? plan.backgroundColor : '#5E152E'" class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex
                                          align-items-center gap-1 row py-1 rounded" style="width:210px ">
                        <!-- *ngIf="plan.parentId != null" -->
                        <div class="my-auto col-1">
                          <input type="checkbox" id="planCheckbox{{plan.id}}"
                            [checked]="allplansArray[product.name][plan.name]?.planCheckbox===true"
                            [disabled]="allplansArray[product.name][plan.name]?.disabled===true"
                            (change)="planCheckbox(product.name,plans.key,plans.value[0].parentId,plan.name,plan.id,$event)" />
                        </div>
                        <div class="my-auto col-9 mb-1  " style="font-size:12px">
                          <span>{{ plan.name }}</span>

                        </div>
                        <div *ngIf="role==='ADMINISTRATOR'"
                          title="{{getTextForTooltip(plan.published.data[0],plan.restrict)}}"
                          [ngStyle]=" { 'border-color' : getColorForPlans(plan.published.data[0],plan.restrict) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans(plan.published.data[0],plan.restrict) }"></span>
                        </div>

                      </div>
                      <div class="mt-2 mx-1" *ngIf="showPricing && plan.id==5">
                        <label class="Corporation">{{lang.Pricing }}</label>
                        <select class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                          [(ngModel)]="editFormPricingOptions" formControlName="pricingOptions">
                          <option value="">{{lang.Select}}</option>
                          <option *ngFor="let option of pricingOptions" [value]="option.key">
                            {{ option.display }}
                          </option>
                        </select>
                      </div>
                      <div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <hr style="    height: 2px;
                                    background-color: black;">
            </div>
          </div>
          <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
            {{lang.Please_select_atleast_one_plan}}
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetFormCreation()">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="editFormSubmit()">
          {{lang.Save}}
        </button> -->
        <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="advisor.addForm()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Model For Edit e&0 Details -->
<div class="modal fade" id="basicModaleditEO" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Edit E&O Details</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="eoform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Insurer_Name}}
                formControlName="insurerName" [(ngModel)]="editEOinsurerName" style="text-transform: capitalize" />

              <div *ngIf="eo['insurerName'].touched && eo['insurerName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                  {{lang.Please_enter_Insurer_name}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                  {{lang.Insurer_name_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                  {{lang.Insurer_name_must_not_exceed_100_characters}}
                </div>
                <!-- <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['minlength']">{{lang.Broker_name_must_be_atleast_3_characters}}</div>
                        <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['maxlength']">Broker name must not exceed 30 characters</div> -->
              </div>
            </div>

            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Certificate}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="certificateNumber"
                placeholder={{lang.Certificate}} formControlName="certificateNumber" [(ngModel)]="editEOcertificate"
                style="text-transform: capitalize" />

              <div *ngIf="
                  eo['certificateNumber'].touched &&
                  eo['certificateNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['certificateNumber'].errors &&
                    eo['certificateNumber'].errors['required']
                  ">
                  {{lang.Please_select_Certificate_Name}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Policy}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="policyNumber" placeholder={{lang.Policy}}
                formControlName="policyNumber" [(ngModel)]="editEOpolicy" style="text-transform: capitalize" />

              <div *ngIf="eo['policyNumber'].touched && eo['policyNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['policyNumber'].errors &&
                    eo['policyNumber'].errors['required']
                  ">
                  {{lang.Please_enter_Policy_Number}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>


              <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                [minDate]="todayDate" [(ngModel)]="editEOExpiryDate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}">
              <div *ngIf="eo['expiryDate'].touched && eo['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="eo['expiryDate'].errors && eo['expiryDate'].errors['required']">{{lang.Please_select_expiry_date}}
                </div>



              </div>
            </div>


          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="hideaddlicenseform()">{{lang.Close}}</button>
        <button type="button" class="btn btn-primary" (click)="editeoinfosumbit()">{{lang.Save}}</button>
      </div>
    </div>
  </div>
</div>

<!-- Model For Add Employee -->
<div class="modal fade" id="addExtraEmail" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Email}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="eoform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Email}}
                formControlName="insurerName" [(ngModel)]="editEOinsurerName" style="text-transform: capitalize" />

              <div *ngIf="eo['insurerName'].touched && eo['insurerName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                  {{lang.Please_enter_Insurer_name}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hideaddlicenseform()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editeoinfosumbit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="BrokerSharedNewDetails"
  tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Broker_Details}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closesharedmodel()"></button>
      </div>
      <!-- <div>
                  <h6 class="admintitle" style="margin-top:10px;"><a class="bartitlelabel">Broker Information&nbsp;&nbsp;<i class="bi bi-info-circle"></i></a></h6>
                  </div> -->
      <div class="modal-body">


        <form class="onbordingform form-container linescrollbar" [formGroup]="brokerregform">

          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Brokers involved in shared account along with
                <strong>{{brokerinfoName1}}?</strong></label>
              <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="brokerCount"
                data-live-search="true" (change)="getbrookercount($event)">

                <option value="" label="" disabled>{{lang.Select}}</option>
                <option value="1" label="">1</option>
                <option value="2" label="">2</option>
                <option value="3" label="">3</option>
                <option value="4" label="">4</option>
                <option value="5" label="">5</option>
              </select>
              <div *ngIf="
    broker['brokerCount'].touched &&
    broker['brokerCount'].invalid
  " class="help-block text-danger">
                <div *ngIf="
      broker['brokerCount'].errors &&
      broker['brokerCount'].errors['required']
    ">
                  {{lang.Please_select_no_of_brokers}}
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="form-group col-3" style="margin-top:23px" *ngIf="showSharedBrokerList">
              <button type="button" data-bs-target="#childInfoModal" style="border-radius:5px" class="btn btn-primary"
                (click)="brokerAdd()">{{lang.Add}}</button>
            </div>
          </div>

          <div></div>
          <br>
          <div class="row salescracking" *ngIf="showsalestrackinCodeAuto">
            <div class="row">
              <div class="col-md-6">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th style='width:80%'>{{lang.broker}}</th>
                      <th style='width:10%'>{{lang.Commissions}}</th>
                      <th style='width:10%'></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let dynamic of brokersalesCodes; let i = index">
                      <td>
                        {{dynamic.brokerName}}
                      </td>
                      <td>
                        <input class="form-control" name="{{ dynamic.commission }}" [(ngModel)]="dynamic.commission"
                          [ngModelOptions]="{ standalone: true }" type="text" maxlength="5" placeholder=""
                          (change)="checkCommisionCode($event)">
                      </td>
                      <td>
                        <button class="fa fa-trash-o deletetier" (click)="deleteRow(i, dynamic)"></button>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                </table>
              </div>

              <div class="col-md-6">
                <canvas id="MyChart">{{ chart }}</canvas>

              </div>
            </div>




          </div>
          <div *ngIf="showaddprofileData">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Select_broker_status}}</label>
              <div class="d-flex">
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="brokerStatus" id="brokerStatusnew" value="false"
                    formControlName="brokerStatus" (change)="sharedBrokerType($event)" />
                  <label for="brokerStatusnew" class="brokerShare my-auto">&nbsp;&nbsp;{{lang.New}}</label>
                </div>
                <div class="form-check form-check-inline d-flex ">
                  <input type="radio" name="brokerStatus" id="brokerStatusexist" value="true"
                    formControlName="brokerStatus" (change)="sharedBrokerType($event)" checked />
                  <label for="brokerStatusexist" class="brokerShare my-auto">&nbsp;&nbsp;{{lang.Existing}}</label>
                </div>

              </div>

              <div *ngIf="
              brokerShared['brokerStatus'].touched &&
              brokerShared['brokerStatus'].invalid
            " class="help-block text-danger">
                <div *ngIf="
                brokerShared['brokerStatus'].errors &&
                brokerShared['brokerStatus'].errors['required']
              ">
                  Please {{lang.Select_broker_status}}
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div *ngIf="showSharedAdvisorData">
              <div class="input-wrapper row" *ngIf="allBrokers && allBrokers.length > 0">
                <div class="form-group col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Brokerage_Parent_Advisor}}</label>

                  <select class="form-control select2" id="parentidrole" placeholder="Select"
                    formControlName="ParentbrokerName" data-live-search="true" (change)="getBrokerlistData($event)">
                    <option value="" label="">{{lang.Select}}</option>
                    <option *ngFor="let broker of allBrokersUnique" [value]="broker.id">
                      <!-- {{ broker.fullName }} -->
                      {{ broker.name }}<span *ngIf="broker.description">-({{ broker.description }})</span>
                      <!-- {{broker.salesTrackingCodeWithStatement}} -->
                    </option>
                  </select>

                  <!-- <div *ngIf="client['corporationName'].touched && client['corporationName'].invalid" class="help-block text-danger">
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please enter corporation name</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">Corporation name must not exceed 30 characters</div>
          </div> -->
                </div>
                <div class="form-group col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>
                  <!-- <select
            class="form-control"
            id="brokerType"
            placeholder="Select"
            formControlName="brokerType">
            <option value="">{{lang.Select}}</option>
            <option value="ADVISOR">Advisor</option>
            <option value="ASSOCIATION">Association</option>
            <option value="BROKERAGE">Brokerage</option>
            <option value="TPA/MGA">TPA/MGA</option>
            </select> -->

                  <select class="form-control" id="brokerType" placeholder="Select"
                    (change)="checkbrokertype(brokername.value)" #brokername formControlName="brokerType">
                    <option value="">{{lang.Select}}</option>

                    <option *ngFor="let name of brokerType" [value]="name.label">
                      {{ name.display }}
                    </option>
                  </select>
                  <div *ngIf="
                broker['brokerType'].touched &&
                broker['brokerType'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['brokerType'].errors &&
                  broker['brokerType'].errors['required']
                ">
                      {{lang.Please_select_role}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-wrapper row">
                <div class="form-group col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Name_of_Broker}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="nameofcorporation"
                    placeholder={{lang.Name_of_Broker}} style="text-transform: capitalize" formControlName="brokersName"
                    (change)="checkAdvsiorNameExist()" />
                  <div *ngIf="
                broker['brokersName'].touched &&
                broker['brokersName'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['brokersName'].errors &&
                  broker['brokersName'].errors['required']
                ">
                      {{lang.Please_enter_broker_name}}
                    </div>
                    <div *ngIf="
                  broker['brokersName'].errors &&
                  broker['brokersName'].errors['minlength']
                ">
                      {{lang.Broker_name_must_be_atleast_3_characters}}
                    </div>
                    <div *ngIf="
                  broker['brokersName'].errors &&
                  broker['brokersName'].errors['maxlength']
                ">
                      {{lang.Broker_name_must_not_exceed_255_characters}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6" *ngIf="showBusinessnumber">
                  <label for="Corporation" class="Corporation">{{lang.Business_Number}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="businessnumber"
                    placeholder={{lang.Business_Number}} formControlName="businessnumber" />
                  <div *ngIf="
                broker['businessnumber'].touched &&
                broker['businessnumber'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['businessnumber'].errors &&
                  broker['businessnumber'].errors['required']
                ">
                      {{lang.Please_enter_business_number}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Phone}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="primaryPhone"
                    (change)="phoneFormat('primaryPhone')" placeholder={{lang.Phone}} formControlName="primaryPhone"
                    (keypress)="numberOnly($event)" />
                  <div *ngIf="
                broker['primaryPhone'].touched &&
                broker['primaryPhone'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['primaryPhone'].errors &&
                  broker['primaryPhone'].errors['required']
                ">
                      {{lang.Please_enter_phone_number}}
                    </div>
                    <div *ngIf="
                  broker['primaryPhone'].errors &&
                  broker['primaryPhone'].errors['minlength']
                ">
                      {{lang.Phone_number_minimum_of_10_digits}}
                    </div>
                    <div *ngIf="
                  broker['primaryPhone'].errors &&
                  broker['primaryPhone'].errors['maxlength']
                ">
                      {{lang.Phone_number_maximum_of_10_digits}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Secondary_Phone}}</label>

                  <input type="text" class="form-control checking-field" (change)="phoneFormat('secondaryPhone')"
                    id="secondaryPhone" placeholder={{lang.Secondary_Phone}} formControlName="secondaryPhone"
                    (keypress)="numberOnly($event)" />
                  <div *ngIf="
                broker['secondaryPhone'].touched &&
                broker['secondaryPhone'].invalid
              " class="help-block text-danger">
                    <!-- <div *ngIf="broker['primaryPhone'].errors && broker['primaryPhone'].errors['required']">{{lang.Please_enter_phone_number}}</div> -->
                    <div *ngIf="
                  broker['secondaryPhone'].errors &&
                  broker['secondaryPhone'].errors['minlength']
                ">
                      {{lang.Phone_number_minimum_of_10_digits}}
                    </div>
                    <div *ngIf="
                  broker['secondaryPhone'].errors &&
                  broker['secondaryPhone'].errors['maxlength']
                ">
                      {{lang.Phone_number_maximum_of_10_digits}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>
                  <!-- <input
            type="text"
            class="form-control checking-field"
            id="email"
            placeholder="Primary Email"
            formControlName="primaryEmail"
            (keypress)="checkEmailValidation($event)"/> -->

                  <input type="text" class="form-control checking-field" type="text" id="email"
                    placeholder={{lang.Email}} formControlName="primaryEmail" />

                  <div *ngIf="
                broker['primaryEmail'].touched &&
                broker['primaryEmail'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['primaryEmail'].errors &&
                  broker['primaryEmail'].errors['required']
                ">
                     {{lang.Please_enter_email}}
                    </div>
                    <div *ngIf="
                  broker['primaryEmail'].errors &&
                  (broker['primaryEmail'].errors['pattern'] ||
                    broker['primaryEmail'].errors['invalidEmail'])
                ">
                      {{lang.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Secondary_Email}}</label>

                  <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Secondary_Email}}
                    formControlName="secondaryEmail" />

                  <div *ngIf="
                broker['secondaryEmail'].touched &&
                broker['secondaryEmail'].invalid
              " class="help-block text-danger">
                    <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                    <div *ngIf="
                  broker['secondaryEmail'].errors &&
                  broker['secondaryEmail'].errors['pattern']
                ">
                      {{lang.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Third_Email}}</label>

                  <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Third_Email}}
                    formControlName="thirdEmail" />

                  <div *ngIf="
                broker['thirdEmail'].touched &&
                broker['thirdEmail'].invalid
              " class="help-block text-danger">
                    <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                    <div *ngIf="
                  broker['thirdEmail'].errors &&
                  broker['thirdEmail'].errors['pattern']
                ">
                      {{lang.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="{{lang.Street_Address}}"
                    placeholder={{lang.Street_Address}} formControlName="streetAddress" />
                  <div *ngIf="
                broker['streetAddress'].touched &&
                broker['streetAddress'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['streetAddress'].errors &&
                  broker['streetAddress'].errors['required']
                ">
                      {{lang.Please_enter_street_address_name}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address_Line_2}} </label>

                  <input type="text" class="form-control checking-field" id="StreetAddreess2"
                    placeholder="{{lang.Street_Address_Line_2}}" formControlName="streetAddress2" />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="city" placeholder={{lang.City}}
                    style="text-transform: capitalize" formControlName="city" />
                  <!-- (keypress)="alphaNumarics($event)" -->
                  <div *ngIf="broker['city'].touched && broker['city'].invalid" class="help-block text-danger">
                    <div *ngIf="
                  broker['city'].errors &&
                  broker['city'].errors['required']
                ">
                      {{lang.Please_enter_city_name}}
                    </div>
                    <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                  <select class="form-control" id="country" placeholder="Country" formControlName="country">
                    <option value="">{{lang.Select}}</option>
                    <option value="canada" selected>Canada</option>
                    <!-- <option value="usa">USA</option> -->

                    <!-- <option
              *ngFor="let name of configprovinceres"
              [value]="name.shortName"
            >
              {{ name.shortName }}
            </option> -->
                  </select>
                  <div *ngIf="
                broker['country'].touched && broker['country'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['country'].errors &&
                  broker['country'].errors['required']
                ">
                      {{lang.Please_select_country}}
                    </div>
                    <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

                  <select class="form-control" id="Province" placeholder="Province" formControlName="Province"
                    (change)="provincelist($event)">
                    <option value="">{{lang.Select}}</option>

                    <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                      {{ name.shortName }}
                    </option>
                  </select>

                  <div *ngIf="
                broker['Province'].touched && broker['Province'].invalid
              " class="help-block text-danger">
                    <div *ngIf="
                  broker['Province'].errors &&
                  broker['Province'].errors['required']
                ">
                      {{lang.Please_select_province}}
                    </div>
                    <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
          <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Postal_Code}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="postalcode" placeholder={{lang.Postal_Code}}
                    formControlName="postalCode" onkeyup="this.value = this.value.toUpperCase();"
                    (input)="changeTextToUppercase('postalcode', $event)" />
                  <div *ngIf="broker['postalCode'].touched" class="help-block text-danger">
                    <div *ngIf="
                  broker['postalCode'].errors &&
                  broker['postalCode'].errors['required']
                ">
                      {{lang.Please_enter_postal_code}}
                    </div>
                    <div *ngIf="
                  invalidpostalcodeprivince ||
                  (broker['postalCode'].touched &&
                    broker['postalCode'].hasError('invalidPostalCode'))
                ">
                      {{lang.Please_enter_valid_postal_code}}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Add {{lang.Group_Contacts}} -->
              <div class="row">
                <div class="form-group col-12 pt-2">
                  <h6 class="admintitle">
                    {{lang.Group_Contacts}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div>
              </div>

              <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadminShared()" *ngIf="addadminform">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.First_Name}}<span  style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                        formControlName="firstName" style="text-transform: capitalize" />

                      <div *ngIf="
                    grpcontact['firstName'].touched &&
                    grpcontact['firstName'].invalid
                  " class="help-block text-danger">
                        <div *ngIf="
                      grpcontact['firstName'].errors &&
                      grpcontact['firstName'].errors['required']
                    ">
                          {{lang.Please_enter_first_Name}}
                        </div>
                        <div *ngIf="
                      grpcontact['firstName'].errors &&
                      grpcontact['firstName'].errors['minlength']
                    ">
                          {{lang.First_Name_should_be_3_characters}}
                        </div>
                        <div *ngIf="
                      grpcontact['firstName'].errors &&
                      grpcontact['firstName'].errors['maxlength']
                    ">
                          {{lang.First_name_must_not_exceed_20_characters}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span  style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                        style="text-transform: capitalize" formControlName="lastName" />

                      <div *ngIf="
                    grpcontact['lastName'].touched &&
                    grpcontact['lastName'].invalid
                  " class="help-block text-danger">
                        <div *ngIf="
                      grpcontact['lastName'].errors &&
                      grpcontact['lastName'].errors['required']
                    ">
                          {{lang.Please_enter_Last_Name}}
                        </div>
                        <div *ngIf="
                      grpcontact['lastName'].errors &&
                      grpcontact['lastName'].errors['minlength']
                    ">
                          {{lang.Last_Name_should_be_3_characters}}
                        </div>
                        <div *ngIf="
                      grpcontact['lastName'].errors &&
                      grpcontact['lastName'].errors['maxlength']
                    ">
                          {{lang.Last_Name_must_not_exceed_20_characters}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span  style="color: red">*</span></label>

                      <input type="tel" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}} (change)="
                    phoneFormatForGroupCont(adminform, 'phoneNum')
                  " formControlName="phoneNum" />

                      <div *ngIf="
                    grpcontact['phoneNum'].touched &&
                    grpcontact['phoneNum'].invalid
                  " class="help-block text-danger">
                        <div *ngIf="
                      grpcontact['phoneNum'].errors &&
                      grpcontact['phoneNum'].errors['required']
                    ">
                          {{lang.Please_enter_phone_number}}
                        </div>
                        <div *ngIf="
                      grpcontact['phoneNum'].errors &&
                      grpcontact['phoneNum'].errors['minlength']
                    ">
                          {{lang.Phone_number_minimum_of_10_digits}}
                        </div>
                        <div *ngIf="
                      grpcontact['phoneNum'].errors &&
                      grpcontact['phoneNum'].errors['maxlength']
                    ">
                          {{lang.Phone_number_maximum_of_10_digits}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                        formControlName="email" (keypress)="checkEmailValidation($event)" />
                      <div *ngIf="
                    grpcontact['email'].touched &&
                    grpcontact['email'].invalid
                  " class="help-block text-danger">
                        <div *ngIf="
                      grpcontact['email'].errors &&
                      grpcontact['email'].errors['required']
                    ">
                         {{lang.Please_enter_email}}
                        </div>
                        <div *ngIf="
                      grpcontact['email'].errors &&
                      grpcontact['email'].errors['pattern']
                    ">
                          {{lang.Please_enter_valid_email}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>

                      <select (change)="groupContactChange($event)" class="form-control" id="adminrole"
                        formControlName="role" placeholder="Role">
                        <option value="null" selected>{{lang.Select}}</option>
                        <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                          {{ name.display }}
                        </option>
                        <!-- <option value="Others">Others</option> -->
                      </select>

                      <div *ngIf="
                    grpcontact['role'].touched &&
                    grpcontact['role'].invalid
                  " class="help-block text-danger">
                        <div *ngIf="
                      grpcontact['role'].errors &&
                      grpcontact['role'].errors['required']
                    ">
                          {{lang.Please_select_role}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4" *ngIf="ShowOthers">
                    <div class="form-group">
                      <label for="Corporation" class="Corporation">{{lang.Others}}<span  style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="OtherRole" placeholder={{lang.Others}}
                        formControlName="roleName" />
                      <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                        <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                          {{lang.please_enter_role}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 pt-2">
                    <button [hidden]="adminform.invalid" type="submit" class="btn btn-primary">
                      {{lang.Save}}
                    </button>
                  </div>
                </div>
              </form>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group" style="margin-bottom: 3px">
                    <div style="overflow: auto; direction: ltr; width: 100%">
                      <table align="left" *ngIf="showaddadmin">
                        <tr>
                          <th>{{lang.First_Name}}</th>
                         <th>{{lang.Last_Name}}</th>
                          <th>{{lang.Phone_Number}}</th>
                          <th>{{lang.Email}}</th>
                          <th>{{lang.Role}}</th>
                          <th></th>
                        </tr>
                        <tbody>
                          <tr *ngFor="let admin of adminSahredData; let i = index" [ngClass]="{
                        orange: i % 2 == 0,
                        white: i % 2 != 0
                      }">
                            <td>{{ admin.firstName }}</td>
                            <td>{{ admin.lastName }}</td>
                            <td>{{ admin.phoneNum }}</td>
                            <td>{{ admin.email }}</td>
                            <td>
                              <span *ngIf="admin.role == 'ADVISOR_EXECUTIVE'">{{lang.Executive}}</span>
                              <span *ngIf="admin.role == 'ADVISOR_ADMINISTRATOR'">{{lang.Administrator}}</span>
                              <span *ngIf="admin.role == 'ADVISOR_CONTACT'">{{lang.Support}}</span>
                              <span *ngIf="admin.role == 'ADVISOR_OTHERS'">{{
                                admin.roleName
                                }}</span>
                            </td>

                            <td style="text-align: right; display: flex">
                              <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                data-bs-target="#basicModaleditgroupcontactShared" (click)="editadminShared(admin, i)">
                                <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                class="btn btn-default deleteicon" (click)="deleteadminShared(admin, i)">
                                <i class="bi bi-trash-fill"></i>
                              </button>

                              <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaleditgroupcontact"(click)="editadmin(admin,i)">Edit</button>&nbsp;
                    <button class="brokertablestatus" style="color:red" (click)="deleteadmin(admin,i)">Delete</button> -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <button *ngIf="showaddadmin" class="btn btn-primary addgroupadmininfo" type="button"
                    data-bs-toggle="modal" data-bs-target="#basicModaladdgrpcontactShared"
                    (click)="hidegrpadmindetailsShared1()">
                    {{lang.Add_More}}
                  </button>
                </div>
              </div>
              <!-- LinceInformation -->
              <div class="row">
                <div class="form-group col-12">
                  <h6 class="admintitle">
                    {{lang.License_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div>
              </div>

              <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicenseShared()"
                *ngIf="addlicenseform">
                <div class="input-wrapper row">
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.License}} #<span  style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="licenseNumber"
                      placeholder={{lang.License}} formControlName="licenseNumber" style="text-transform: capitalize" />

                    <div *ngIf="
                  f['licenseNumber'].touched && f['licenseNumber'].invalid
                " class="help-block text-danger">
                      <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['required']
                  ">
                        {{lang.Please_enter_license_number}}
                      </div>
                      <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['minlength']
                  ">
                        {{lang.License_number_must_be_atleast_3_characters}}
                      </div>
                      <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['maxlength']
                  ">
                        {{lang.License_number_must_not_exceed_100_characters}}s
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

                    <select class="form-control" formControlName="licenseCoverage">
                      <option value="" selected>{{lang.Select}}</option>
                      <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                        {{ name.display }}
                      </option>
                    </select>
                    <!-- <select class="form-control" formControlName="licenseCoverage1">
            <option value="" Selected>Select</option>
          </select> -->

                    <div *ngIf="
                  f['licenseCoverage'].touched &&
                  f['licenseCoverage'].invalid
                " class="help-block text-danger">
                      <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                        {{lang.Please_select_license_coverage}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

                    <select class="form-control" id="state" placeholder="state" formControlName="state"
                      (change)="insuranceprovincelist($event)">
                      <option value="" label="" disabled>{{lang.Select}}</option>
                      <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                        {{ name.shortName }}
                      </option>
                    </select>

                    <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                      <div *ngIf="
                    f['state'].errors && f['state'].errors['required']
                  ">
                        {{lang.Please_select_province}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>

                    <input type="text" placeholder="MM-DD-YYYY" class="form-control" [min]="minDate"
                      formControlName="expiryDate" [placement]='"top"' bsDatepicker [minDate]="todayDate"
                      [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" (onShown)="disableScrolling()"
                      (onHidden)="enableScrolling()" />
                    <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                      <div *ngIf="
                    f['expiryDate'].errors &&
                    f['expiryDate'].errors['required']
                  ">
                        {{lang.Please_select_expiry_date}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
                    <input type="text" class="form-control checking-field" id="remainder_days" value="30"
                      placeholder={{lang.Reminder_Days}} (keypress)="numberOnly($event)" formControlName="remainder_days"
                      style="text-transform: capitalize" />

                    <div *ngIf="
                  f['remainder_days'].touched &&
                  f['remainder_days'].invalid
                " class="help-block text-danger">
                      <div *ngIf="
                    f['remainder_days'].errors &&
                    f['remainder_days'].errors['required']
                  ">
                        {{lang.Please_enter_reminder_email_days}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12">
                    <button type="submit" [hidden]="licenseform.invalid" class="btn btn-primary">
                      {{lang.Save}}
                    </button>
                  </div>
                </div>
              </form>
              <!-- lincenseInfo Table -->
              <div class="row">
                <div class="form-group col-12">
                  <div style="direction: ltr; width: 100%">
                    <div class="row">
                      <div class="form-group col-12" style="margin-bottom: 3px">
                        <!-- <div style="overflow: auto; direction:ltr;  width: 100%;"> -->
                        <table align="left" *ngIf="addlicenseformtable">
                          <tr>
                            <th>{{lang.License}} #</th>
                            <th>{{lang.Coverage}} </th>
                            <th>{{lang.Province}} </th>
                            <th>{{lang.Expiry_Date}} </th>
                            <th>{{lang.Reminder_Days}} </th>
                            <th></th>
                          </tr>
                          <tbody>
                            <tr *ngFor="
                          let broker of addlicenseformDataShared;
                          let i = index
                        " [ngClass]="{
                          orange: i % 2 == 0,
                          white: i % 2 != 0
                        }">
                              <td>
                                <input type="text" class="form-control checking-field" id="licenseNumber"
                                  [(ngModel)]="broker.licenseNumber" [ngModelOptions]="{ standalone: true }" [disabled]="
                              isEditable || enableEditIndex != i
                            " />
                              </td>
                              <td>
                                <select class="form-control" id="licenseCoverage" placeholder="Select"
                                  [(ngModel)]="broker.licenseCoverage" [ngModelOptions]="{ standalone: true }"
                                  [disabled]="
                              isEditable || enableEditIndex != i
                            ">
                                  <option value="" disabled>{{lang.Select}}</option>

                                  <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                                    {{ name.display }}
                                  </option>
                                </select>
                              </td>
                              <td>
                                <select class="form-control" id="province" placeholder="Select"
                                  (change)="insuranceprovincelist($event)" [(ngModel)]="broker.provinceshortName"
                                  [ngModelOptions]="{ standalone: true }" [disabled]="
                              isEditable || enableEditIndex != i
                            ">
                                  <option value="" disabled>{{lang.Select}}</option>
                                  <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                                    {{ name.shortName }}
                                  </option>
                                </select>
                              </td>
                              <td>
                                <input type="text" placeholder="MM-DD-YYYY" class="form-control" [min]="minDate"
                                  [(ngModel)]="broker.expiryDate" [ngModelOptions]="{ standalone: true }" [disabled]="
                              isEditable || enableEditIndex != i
                            " bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                              </td>
                              <td>
                                <input type="text" class="form-control checking-field" id="remainder_days"
                                  placeholder="Reminder Days" (keypress)="numberOnly($event)"
                                  [(ngModel)]="broker.remainder_days" [ngModelOptions]="{ standalone: true }"
                                  style="text-transform: capitalize" [disabled]="
                              isEditable || enableEditIndex != i
                            " />
                              </td>
                              <td style="display: flex; margin-top: 10px">
                                <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                  data-bs-target="#basicModaleditShared" (click)="
                              editadvisorlicenseDetailsShared($event, i, broker)
                            " *ngIf="enableEditIndex != i">
                                  <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                  class="btn btn-default deleteicon" (click)="deletelicenseShared(broker, i)"
                                  *ngIf="enableEditIndex != i">
                                  <i class="bi bi-trash-fill"></i>
                                </button>

                                <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaledit" (click)="editadvisorlicenseDetails($event, i,broker)" *ngIf="enableEditIndex != i">Edit</button>&nbsp;
                        <button class="brokertablestatus" style="color:red" (click)="deletelicense(broker,i)" *ngIf="enableEditIndex != i">Delete</button> -->
                                <button class="brokertablestatus" style="color: green"
                                  *ngIf="!isEditable && enableEditIndex == i" (click)="saveLicense(broker, i)">
                                  {{lang.Save}}</button>&nbsp;
                                <button class="brokertablestatus" style="color: red"
                                  *ngIf="!isEditable && enableEditIndex == i" (click)="cancellicneseEdit($event, i)">
                                  {{lang.Cancel}}
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <button *ngIf="addlicenseformtable"  class="btn btn-primary addgroupadmininfo" type="button"  data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="hidegrpadmindetails()" >{{lang.Add_More}}</button> -->

                        <!-- </div> -->
                      </div>
                    </div>

                    <button *ngIf="addlicenseformtable" class="btn btn-primary addgroupadmininfo" type="button"
                      data-bs-toggle="modal" data-bs-target="#basicModal1Shared" (click)="addnewlicenseShared()">
                      {{lang.Add_More}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- {{lang.E_O_Information}} -->
              <div class="row pt-2">
                <div class="form-group col-12">
                  <h6 class="admintitle">
                    {{lang.E_O_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div>
              </div>

              <form class="onbordingform" [formGroup]="eoform" (ngSubmit)="addEOformDetails()" *ngIf="addEOform">
                <div class="input-wrapper row">
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>
                    <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Insurer_Name}}
                      formControlName="insurerName" style="text-transform: capitalize" />
                    <div *ngIf="
                  eo['insurerName'].touched && eo['insurerName'].invalid
                " class="help-block text-danger">
                      <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                        {{lang.Please_enter_Insurance_name}}
                      </div>
                      <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                        {{lang.Insurer_name_must_be_atleast_3_characters}}
                      </div>
                      <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                        {{lang.Insurer_name_must_not_exceed_100_characters}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
                    <input type="text" class="form-control checking-field" id="certificateNumber"
                      placeholder={{lang.Certificate}} formControlName="certificateNumber" />

                    <div *ngIf="
                  eo['certificateNumber'].touched &&
                  eo['certificateNumber'].invalid
                " class="help-block text-danger">
                      <div *ngIf="
                    eo['certificateNumber'].errors &&
                    eo['certificateNumber'].errors['required']
                  ">
                        {{lang.Please_select_Certificate_Name}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

                    <input type="text" class="form-control checking-field" id="PolicyNumber" placeholder={{lang.Policy}}
                      formControlName="policyNumber" />

                    <div *ngIf="eo['policyNumber'].touched && eo['policyNumber'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="
                    eo['policyNumber'].errors && eo['policyNumber'].errors['required']
                  ">
                        {{lang.Please_enter_Policy_Number}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-wrapper row">
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

                    <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                      (onShown)="disableScrolling()" (onHidden)="enableScrolling()" [placement]='"top"'
                      [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"/>
                    <div *ngIf="
                  eo['expiryDate'].touched &&
                  eo['expiryDate'].invalid
                " class="help-block text-danger">
                      <div *ngIf="
                    eo['expiryDate'].errors &&
                    eo['expiryDate'].errors['required']
                  ">
                        {{lang.Please_select_expiry_date}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4"></div>
                  <div class="form-group col-12">
                    <button type="submit" [hidden]="eoform.invalid" class="btn btn-primary">
                      {{lang.Save}}
                    </button>
                  </div>
                </div>
              </form>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div style="overflow: auto; direction: ltr; width: 100%">
                      <table align="left" *ngIf="showaddEOdetails">
                        <tr>
                          <th>{{lang.Insurer_Name}}</th>
                          <th>{{lang.Certificate}} #</th>
                          <th>{{lang.Policy}} #</th>
                          <th>{{lang.Expiry_Date}} </th>
                          <th></th>
                        </tr>
                        <tbody>
                          <tr>
                            <td>{{ EOinsurenceInfo.insurerName }}</td>
                            <td>
                              {{ EOinsurenceInfo.certificateNumber | titlecase }}
                            </td>
                            <td>{{ EOinsurenceInfo.policyNumber }}</td>
                            <td>
                              {{
                              EOinsurenceInfo.expiryDate
                              | date: 'MMM dd, yyyy'
                              }}
                            </td>
                            <td style="text-align: right; display: flex">
                              <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                data-bs-target="#basicModaleoeditShared" (click)="editEOShared()">
                                <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                class="btn btn-default deleteicon" (click)="deleteEOShared()">
                                <i class="bi bi-trash-fill"></i>
                              </button>

                              <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaleoedit"(click)="editEO()">Edit</button>&nbsp;
                  <button class="brokertablestatus" style="color:red" (click)="deleteEO()">Delete</button> -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- <button *ngIf="showaddadmin"  class="btn btn-primary addgroupadmininfo" type="button"  data-bs-toggle="modal" data-bs-target="#basicModaladdgrpcontact" (click)="hidegrpadmindetails()" >{{lang.Add_More}}</button> -->
                </div>
              </div>
              <br>
              <div *ngIf="showSharedAdvisorData" style="display: flex;justify-content: flex-end;">
                <button class="btn btn-primary" type="button" (click)="submitSharedNew()">
                  {{lang.Submit}}
                </button>&nbsp;
                <!-- <button class="btn btn-primary addgroupadmininfo" type="button" (click)="addRow()">
            {{lang.Add_More}}
          </button> -->





              </div>



            </div>
            <div *ngIf="!showSharedAdvisorData">
              <div class="input-wrapper row" *ngIf="allBrokers && allBrokers.length > 0">
                <div class="form-group col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Existing_Broker_Advisor}}</label>

                  <!-- <select class="form-control select2" id="parentidrole" placeholder="Select"
                  formControlName="ParentbrokerName" [(ngModel)]="getsharedexisting" data-live-search="true"
                  (change)="getBrokerSharedExisting($event)">
                  <option value="" label="">Select</option>
                  <option *ngFor="let broker of allBrokersUnique" [ngValue]="broker">
                    {{ broker.name }}<span *ngIf="broker.description">-({{ broker.description }})</span>
                  </option>
                </select> -->
                  <ng-multiselect-dropdown #multiSelectDropdown formControlName="ParentbrokerName"
                    placeholder={{lang.Select}} [settings]="dropdownSettings1" [data]="allBrokersUnique"
                    (onSelect)="multiSelectAdvsiorSelect($event)" (onSelectAll)="multiSelectAdvisorSelectAll($event)"
                    (onDeSelect)="multiSelectAdvisorItemDeSelect($event)" (onDeSelectAll)="
                  multiSelectAdvisorDeSelectAll($event)
                ">
                  </ng-multiselect-dropdown>

                  <!-- <div *ngIf="client['corporationName'].touched && client['corporationName'].invalid" class="help-block text-danger">
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please enter corporation name</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">Corporation name must not exceed 30 characters</div>
          </div> -->
                </div>


              </div>
            </div>
          </div>
          <div *ngIf="showsharedformData">
            <form class="onbordingform form-container linescrollbar" [formGroup]="brokerSharedregform">
              <div class="input-wrapper row" *ngIf="allBrokers && allBrokers.length > 0">
                <div class="form-group col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Brokerage_Parent_Advisor}}</label>

                  <select class="form-control select2" id="parentidrole" placeholder="Select"
                    formControlName="ParentbrokerName" data-live-search="true" (change)="getBrokerlistData($event)">
                    <option value="" label="">{{lang.Select}}</option>
                    <option *ngFor="let broker of allBrokersUnique" [value]="broker.id">
                      <!-- {{ broker.fullName }} -->
                      {{ broker.name }}<span *ngIf="broker.description">-({{ broker.description }})</span>
                      <!-- {{broker.salesTrackingCodeWithStatement}} -->
                    </option>
                  </select>

                  <div *ngIf="
        brokerShared['ParentbrokerName'].touched &&
        brokerShared['ParentbrokerName'].invalid
      " class="help-block text-danger">
                    <div *ngIf="
          brokerShared['ParentbrokerName'].errors &&
          brokerShared['ParentbrokerName'].errors['required']
        ">
                      {{lang.Please_select_parent_advisor}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Shared_account_name}}</label>

                  <input type="text" class="form-control checking-field" id="nameofcorporation"
                    placeholder="Name of shared account" style="text-transform: capitalize"
                    formControlName="brokersName" (change)="checkAdvsiorNameExistshared()" />
                  <div *ngIf="
            brokerShared['brokersName'].touched &&
            brokerShared['brokersName'].invalid
          " class="help-block text-danger">
                    <div *ngIf="
              brokerShared['brokersName'].errors &&
              brokerShared['brokersName'].errors['required']
            ">
                      {{lang.Please_enter_broker_name}}
                    </div>
                    <div *ngIf="
              brokerShared['brokersName'].errors &&
              brokerShared['brokersName'].errors['minlength']
            ">
                      {{lang.Broker_name_must_be_atleast_3_characters}}
                    </div>
                    <div *ngIf="
              brokerShared['brokersName'].errors &&
              brokerShared['brokersName'].errors['maxlength']
            ">
                      {{lang.Broker_name_must_not_exceed_255_characters}}
                    </div>
                  </div>
                </div>

              </div>







              <div></div>
              <br>
              <div style="display: flex;justify-content: flex-end;">
                <button class="btn btn-primary" type="button" (click)="submitSharedNewandexisting()">
                  {{lang.Submit}}
                </button>&nbsp;
              </div>
              <!-- <button class="btn btn-primary addgroupadmininfo" type="button" (click)="addRow()">
{{lang.Add_More}}
</button> -->






            </form>
          </div>
          <!-- <div *ngIf="!showSharedAdvisorData" style="display: flex;justify-content: flex-end;">
  <button class="btn btn-primary" type="button" (click)="submitSharedExisting()">
    Submit
  </button>&nbsp;







</div> -->
        </form>

      </div>


    </div>
  </div>
</div>
<div class="modal fade" id="basicModaleditgroupcontactShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hidegrpadmindetailsShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="phoneNum"
                (change)="phoneFormatDynamic('phoneNum', 'grpcontact')" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" formControlName="phoneNum" />

              <div *ngIf="
                  grpcontact['phoneNum'].touched &&
                  grpcontact['phoneNum'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                 {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                        grpcontact['email'].errors &&
                        grpcontact['email'].errors['emailExist']
                                  ">
                  {{lang.Email_aldready_exists}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>
              <select class="form-control" id="lengthofService" (change)="groupContactChange($event)"
                formControlName="role" name="adminrole">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
                <!-- <option value="Others" >Others</option> -->
              </select>

              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="ShowOthers">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Others}}<span  style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="OtherRole" placeholder={{lang.Others}}
                  formControlName="roleName" />
                <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                    {{lang.please_enter_role}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetailsShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editadminSubmitShared()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="basicModaladdgrpcontactShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hidegrpadmindetailsShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && grpcontact['adminfirstname'].errors" class="invalid-feedback">
                        <div *ngIf="grpcontact['adminfirstname'].errors['required']">First Name is required</div>
                        <div *ngIf="grpcontact['adminfirstname'].errors['minlength']">
                          First Name must be at least 3 characters
                        </div>
                        <div *ngIf="grpcontact['adminfirstname'].errors['maxlength']">
                          {{lang.First_name_must_not_exceed_20_characters}}
                        </div>
                      </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span  style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="phoneNum"
                (change)="phoneFormatDynamic('phoneNum', 'grpcontact')" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" formControlName="phoneNum" />

              <div *ngIf="
                  grpcontact['phoneNum'].touched &&
                  grpcontact['phoneNum'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <!-- <div *ngIf="grpcontact['adminphone'].errors && grpcontact['adminphone'].errors['pattern']">Please enter valid phone number</div> -->
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                 {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                                    grpcontact['email'].errors &&
                                    grpcontact['email'].errors['emailExist']
                                  ">
                  {{lang.Email_aldready_exists}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span  style="color: red">*</span></label>

              <select class="form-control" id="lengthofService" formControlName="role" name="adminrole"
                (change)="groupContactChange($event)">
                <option value="null" disabled selected>Select</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
                <!-- <option value="Others">Others</option> -->
              </select>

              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="ShowOthers">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Others}}<span  style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="OtherRole" placeholder={{lang.Others}}
                  formControlName="roleName" />
                <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                    {{lang.please_enter_role}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hidegrpadmindetailsShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="addadminShared()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" id="basicModaleoeditShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_EO}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hidegrpadmindetailsSharedEO()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="eoform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>
              <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Insurer_Name}}
                formControlName="insurerName" style="text-transform: capitalize" />
              <div *ngIf="eo['insurerName'].touched && eo['insurerName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                  {{lang.Please_enter_Insurer_name}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                  {{lang.Insurer_name_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                  {{lang.Insurer_name_must_not_exceed_100_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
              <input type="text" class="form-control checking-field" id="certificateNumber"
                placeholder={{lang.Certificate}} formControlName="certificateNumber" />

              <div *ngIf="
                  eo['certificateNumber'].touched && eo['certificateNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['certificateNumber'].errors &&
                    eo['certificateNumber'].errors['required']
                  ">
                  Please select Certificate Name
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

              <input type="text" class="form-control checking-field" id="PolicyNumber" placeholder={{lang.Policy}}
                formControlName="policyNumber" />

              <div *ngIf="eo['policyNumber'].touched && eo['policyNumber'].invalid" class="help-block text-danger">
                <div *ngIf="eo['policyNumber'].errors && eo['policyNumber'].errors['required']">
                  {{lang.Please_enter_Policy_Number}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

              <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="
                  eo['expiryDate'].touched && eo['expiryDate'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['expiryDate'].errors &&
                    eo['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4"></div>
            <div class="form-group col-4">
              <!-- <button  type="submit" [hidden]="eoform.invalid" class="btn btn-primary">Save</button> -->
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetailsSharedEO()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editEOSharedSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Model for edit license Shared broker -->
<div class="modal fade" id="basicModaleditShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_License}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hideaddlicenseformShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNumber" [(ngModel)]="editbrokerlicensenumber"
                style="text-transform: capitalize" />

              <div *ngIf="f['licenseNumber'].touched && f['licenseNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage"
                [(ngModel)]="editbrokerlicensecoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                [(ngModel)]="editbrokerlicenseshortName" (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>

              <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" [(ngModel)]="editbrokerlicenseexpirydate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                [(ngModel)]="editbrokerlicenseexpiryremainder" (keypress)="numberOnly($event)"
                formControlName="remainder_days" style="text-transform: capitalize" />

              <div *ngIf="
                  f['remainder_days'].touched && f['remainder_days'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['remainder_days'].errors &&
                    f['remainder_days'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_email_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="hideaddlicenseform btn-secondary" data-bs-dismiss="modal"
          (click)="hideaddlicenseformShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editbrokerlicenseSharedSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="basicModal1Shared" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Broker_License}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hideaddlicenseformShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNumber" style="text-transform: capitalize" />

              <div *ngIf="f['licenseNumber'].touched && f['licenseNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span  style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span  style="color: red">*</span></label>

              <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                (keypress)="numberOnly($event)" formControlName="remainder_days" style="text-transform: capitalize" />

              <div *ngIf="
                  f['remainder_days'].touched && f['remainder_days'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['remainder_days'].errors &&
                    f['remainder_days'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hideaddlicenseformShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="licenseform.invalid" (click)="addlicenseShared()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<footer id="footer" class="footer">
  <div class="copyright">
    Version IB:3.0.0 © 2025 :
    <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank">
      The GroupBenefitz Platform Inc.</a>
  </div>
</footer>
<a (click)="scrollTop()" class="back-to-top d-flex align-items-center justify-content-center"><i
    class="bi bi-arrow-up-short"></i></a>
